<template>
  <div style="width: 100vw; height: 100vh; position: relative;">
    <div v-if="loadingPage" style="display: block;width: 50%;height: 100vh;
    text-align: center;margin: auto;padding-top: 15%;">
      <v-progress-circular :size="200" :width="20" color="primary" indeterminate></v-progress-circular>
    </div>

    <v-navigation-drawer v-model="showGridViagens" absolute temporary overlay-opacity="0.5" right
      style="width: 50%; z-index: 5000; min-width: 320px;">
      <QuadroViagens v-if="quadroViagensMounted" :items-per-page="8" />
    </v-navigation-drawer>

    <!-- Lista de Linhas -->
    <v-navigation-drawer v-model="showingDrawerLinhas" absolute temporary overlay-opacity="0" left
      style="width: 30%; z-index: 5000; min-width: 320px;">
      <!-- DIV para mostrar e filtrar linhas -->
      <div v-if="pageLoaded" style="width: 100%; height: 82vh; float: left; padding-right: 5px">
        <v-toolbar style="
                margin-bottom: 5px;
                margin-left: 3px;
                margin-top: 5px;
                border-radius: 10px;
              ">
          <v-row align="center">
            <v-text-field append-outer-icon="mdi-refresh" @click:append-outer="populaLinhasOperacao" v-model="search"
              append-icon="mdi-magnify" :label=labelProcurar single-line hide-details
              style="padding-left: 20px; padding-right: 20px"></v-text-field>
          </v-row>
        </v-toolbar>

        <v-toolbar flat color="blue-grey lighten-4" style="border-radius: 10px">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip class="ma-2" v-on="on" @click="
                showDialogStatusVeiculos(
                  0,
                  $t('operation.totalActiveVehicles'),
                  false,
                  null,
                  null
                )
                " style="
                      background-color: #1565c0;
                      color: white;
                      text-align: center;
                    ">
                <h3>{{ veiculos.length }}</h3>
              </v-chip>
            </template>
            <span>{{ $t('operation.totalActiveVehicles') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" class="ma-2" @click="
                showDialogStatusVeiculos(
                  1,
                  $t('operation.totalGpsOnlineVehicles'),
                  false,
                  null,
                  null
                )
                " style="background-color: green; color: white">
                <h3>{{ totalcarrosonline }}</h3>
              </v-chip>
            </template>
            <span>{{ $t('operation.totalGpsOnlineVehicles') }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" @click="
                showDialogStatusVeiculos(
                  2,
                  $t('operation.totalGpsOfflineVehicles'),
                  false,
                  null,
                  null
                )
                " class="ma-2" style="background-color: orange; color: white">
                <h3>{{ totalcarrosgpsoffline }}</h3>
              </v-chip>
            </template>
            <span>{{ $t('operation.totalGpsOfflineVehicles') }}</span>
          </v-tooltip>

          <v-tooltip top v-if="showInfoValidador">
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" class="ma-2" @click="
                showDialogStatusVeiculos(
                  3,
                  $t('operation.totalValidatorOfflineVehicles'),
                  false,
                  null,
                  null
                )
                " style="background-color: red; color: white">
                <h3>{{ totalcarrosvalidadoroffline }}</h3>
              </v-chip>
            </template>
            <span>{{ $t('operation.totalValidatorOfflineVehicles') }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-list dense class="overflow-y-auto" style="border-radius: 10px; height: 74vh; margin-left: 3px">
          <v-list-group v-for="item in filteredUnidades" :key="`U-${item.id_unidade}`"
            style="border: 2px #4a4a4a solid; border-radius: 5px; margin-bottom: 2px">
            <template v-slot:activator>
              <v-list-item-title>
                <v-card rounded style="margin: 0px; padding: 5px;">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip @click.stop="
                        showDialogStatusVeiculos(
                          4,
                          $t('operation.totalActiveVehiclesUnit'),
                          true,
                          item.id_unidade,
                          item.descricao_unidade
                        )
                        " v-on="on" class="ma-2" small style="
                              background-color: #1565c0;
                              color: white;
                              text-align: center;
                            ">{{ item.total_veiculos }}</v-chip>
                    </template>
                    <span>{{ $t('operation.totalActiveVehiclesUnit') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip class="ma-2" small @click.stop="
                        showDialogStatusVeiculos(
                          5,
                          $t('operation.totalGpsValidatorOnlineUnit'),
                          true,
                          item.id_unidade,
                          item.descricao_unidade
                        )
                        " v-on="on" style="background-color: green; color: white">{{ item.total_veiculos_online
                        }}</v-chip>
                    </template>
                    <span>{{ $t('operation.totalGpsValidatorOnlineUnit') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip class="ma-2" small v-on="on" @click.stop="
                        showDialogStatusVeiculos(
                          6,
                          $t('operation.totalGpsOfflineUnit'),
                          true,
                          item.id_unidade,
                          item.descricao_unidade
                        )
                        " style="background-color: orange; color: white">{{ item.total_gps_offline }}</v-chip>
                    </template>
                    <span>{{ $t('operation.totalGpsOfflineUnit') }}</span>
                  </v-tooltip>

                  <v-tooltip top v-if="showInfoValidador">
                    <template v-slot:activator="{ on }">
                      <v-chip class="ma-2" small v-on="on" @click.stop="
                        showDialogStatusVeiculos(
                          7,
                          $t('operation.totalValidatorOfflineUnit'),
                          true,
                          item.id_unidade,
                          item.descricao_unidade
                        )
                        " style="background-color: red; color: white">{{ item.total_validador_offline }}</v-chip>
                    </template>
                    <span>{{ $t('operation.totalValidatorOfflineUnit') }}</span>
                  </v-tooltip>
                  <v-list-item-subtitle>
                    <span style="font-weight: bold;">{{ item.cod_unidade }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-text="item.descricao_unidade"></v-list-item-subtitle>
                </v-card>
              </v-list-item-title>
            </template>
            <v-list-item>
              <v-list-item-content>
                <v-list three-line class="overflow-y-auto" select-strategy="classic">
                  <v-list-item-group v-model="selectedItem" color="primary">
                    <v-list-item v-for="linha in (linhasPorUnidade.get(item.id_unidade) || [])"
                      :key="`L-${linha.id_linha}`" @click="listItemClicked(linha)"
                      :style="selectedLinhaStyle(linha)">
                      <v-list-item-content>
                        <v-list-item-title color="primary">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip @click.stop="
                                showDialogStatusVeiculos(
                                  0,
                                  $t('operation.totalActiveVehiclesLine'),
                                  true,
                                  linha.id_linha,
                                  linha.nome_linha
                                )
                                " v-on="on" class="ma-2" small style="
                                    background-color: #1565c0;
                                    color: white;
                                    text-align: center;
                                  ">{{ linha.total_veiculos }}</v-chip>
                            </template>
                            <span>{{ $t('operation.totalActiveVehiclesLine') }}</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip class="ma-2" small @click.stop="
                                showDialogStatusVeiculos(
                                  1,
                                  $t('operation.totalGpsValidatorOnlineLine'),
                                  true,
                                  linha.id_linha,
                                  linha.nome_linha
                                )
                                " v-on="on" style="background-color: green; color: white">{{
                                  linha.total_veiculos_online }}</v-chip>
                            </template>
                            <span>{{ $t('operation.totalGpsValidatorOnlineLine') }}</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip class="ma-2" small v-on="on" @click.stop="
                                showDialogStatusVeiculos(
                                  2,
                                  $t('operation.totalGpsOfflineLine'),
                                  true,
                                  linha.id_linha,
                                  linha.nome_linha
                                )
                                " style="background-color: orange; color: white">{{ linha.total_gps_offline
                                }}</v-chip>
                            </template>
                            <span>{{ $t('operation.totalGpsOfflineLine') }}</span>
                          </v-tooltip>

                          <v-tooltip top v-if="showInfoValidador">
                            <template v-slot:activator="{ on }">
                              <v-chip class="ma-2" small v-on="on" @click.stop="
                                showDialogStatusVeiculos(
                                  3,
                                  $t('operation.totalValidatorOfflineLine'),
                                  true,
                                  linha.id_linha,
                                  linha.nome_linha
                                )
                                " style="background-color: red; color: white">{{ linha.total_validador_offline
                                }}</v-chip>
                            </template>
                            <span>{{ $t('operation.totalValidatorOfflineLine') }}</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-row>
                          <v-col cols="12" sm="8">
                            <v-list-item-subtitle v-text="linha.razao_social"
                              :style="selectedLinhaSubtitleStyle(linha)"></v-list-item-subtitle>
                            <v-list-item-subtitle v-text="linha.nome_linha"
                              :style="selectedLinhaSubtitleStyle(linha)"></v-list-item-subtitle>
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-btn dark color="primary" small @click.stop="openQuadroSinotico(linha)">
                              {{ $t('operation.synoptic') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </v-list-item-group>
                </v-list>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list-group>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="showingDrawer" absolute temporary overlay-opacity="0" right dark
      style="width: 30%; z-index: 5000">
      <template v-if="drawerVeiculosMounted">
      <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
        <v-text-field v-model="searchCarros" append-icon="mdi-magnify" :label="$t('operation.searchVehicle')"
          single-line hide-details></v-text-field>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('operation.filtersTitle') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- <v-checkbox
              v-model="filters"
              :label="`Múltiplas Guias (${totalcarrosmultiplasguias})`"
              value="Múltiplas Guias"
              @change="filterChanged"
            >
            </v-checkbox> -->

            <v-checkbox
              v-model="filters"
              :value="$t('operation.inconsistentLine')"
              @change="filterChanged"
              v-if="showInfoValidador"
            >
              <template v-slot:label>
                {{ $t('operation.inconsistentLine') }} ({{ totalcarroslinhainconsistenteguia }})
              </template>
            </v-checkbox>

            <v-checkbox
              v-model="filters"
              :value="$t('operation.inconsistentDriver')"
              @change="filterChanged"
              v-if="showInfoValidador"
            >
              <template v-slot:label>
                {{ $t('operation.inconsistentDriver') }} ({{ totalcarrosmotoristainconsistenteguia }})
              </template>
            </v-checkbox>

            <v-checkbox
              v-model="filters"
              :value="$t('operation.inconsistentCollector')"
              @change="filterChanged"
              v-if="showInfoValidador"
            >
              <template v-slot:label>
                {{ $t('operation.inconsistentCollector') }} ({{ totalcarroscobradorinconsistenteguia }})
              </template>
            </v-checkbox>

            <v-divider class="my-2" v-if="statusFiltrosDisponiveis.length > 0"></v-divider>
            <div v-if="statusFiltrosDisponiveis.length > 0" class="subtitle-2 mb-1">
              {{ $t('operation.statusFilterTitle') }}
            </div>
            <v-checkbox
              v-for="status in statusFiltrosDisponiveis"
              :key="status.cod_status"
              v-model="statusFilters"
              :value="status.cod_status"
              @change="filterChanged"
            >
              <template v-slot:label>
                <v-chip x-small :color="status.cor" class="mr-2" label>&nbsp;</v-chip>
                <span>{{ status.descricao }} ({{ contagemPorStatus.get(status.cod_status) || 0 }})</span>
              </template>
            </v-checkbox>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-for="item in filteredVeiculos" :key="`DRAWER-V-${item.id_veiculo}`"
          @click="detalhesVeiculoClicked(item)">
          <v-expansion-panel-header class="font-weight-bold" style="color: grey">
            <v-chip :color="colorChipVeiculo(item)">
              {{ item.cod_veiculo }}
            </v-chip>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <pre>{{ $t("vehicle.code") }} : {{ item.cod_veiculo }}</pre>
            <br />
            <pre>{{ $t("vehicle.plate") }} : {{ item.placa }}</pre>
            <br />
            <pre>{{ $t("operation.gpsDate") }} : {{ item.dt_gps }}</pre>
            <br />
            <pre>{{ $t("operation.gpsLatitude") }} : {{ item.lat }}</pre>
            <br />
            <pre>{{ $t("operation.gpsLongitude") }} : {{ item.lng }}</pre>
            <br />
            <pre>{{ $t("operation.heading") }} : {{ item.rumo }}</pre>
            <pre v-if="showInfoValidador">{{ $t("operation.validatorDate") }} : {{ item.dt_validador }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.validatorLatitude") }} : {{ item.lat_bilhetagem }}</pre>
            <pre>{{ $t("operation.speed") }} : {{ item.velocidade }}</pre>
            <br />
            <pre>{{ $t("operation.integrationCode") }} : {{ item.cod_integracao }}</pre>
            <br />
            <pre>{{ $t("operation.gpsStatus") }} : {{ item.gps_offline === 1 ? "OFFLINE" : "ONLINE" }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.validatorStatus") }} : {{ item.validador_offline === 1 ?
              "OFFLINE" : "ONLINE" }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.validatorInfo") }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $tc("line.self", 1) }} : {{ item.nome_linha }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.direction") }} : {{ item.sentido_validador_extenso }}</pre>
            <br />
            <pre
              v-if="showInfoValidador">{{ $t("operation.driverRegistration") }} : {{ item.matricula_motorista }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.driverName") }} : {{ item.nome_motorista }}</pre>
            <br />
            <pre
              v-if="showInfoValidador">{{ $t("operation.collectorRegistration") }} : {{ item.matricula_cobrador }}</pre>
            <br />
            <pre v-if="showInfoValidador">{{ $t("operation.collectorName") }} : {{ item.nome_cobrador }}</pre>
            <br />
            <pre>{{ $t("operation.info") }} {{ ordemDeServico }}</pre>
            <br />
            <pre>{{ $tc("line.self", 1) }} : {{ item.nome_linha_guia }}</pre>
            <pre>{{ $tc("line.self", 1) }} : {{ item.nome_linha_guia }}</pre>
            <br />
            <pre>{{ $t("operation.driverRegistration") }} : {{ item.matricula_motorista_guia }}</pre>
            <br />
            <pre>{{ $t("operation.driverName") }} : {{ item.nome_motorista_guia }}</pre>
            <pre>{{ $t("operation.driverName") }} : {{ item.nome_motorista_guia }}</pre>
            <br />
            <pre>{{ $t("operation.collectorRegistration") }} : {{ item.matricula_cobrador_guia }}</pre>
            <pre>{{ $t("operation.collectorRegistration") }} : {{ item.matricula_cobrador_guia }}</pre>
            <br />
            <pre>{{ $t("operation.collectorName") }} : {{ item.nome_cobrador_guia }}</pre>
            <pre>{{ $t("operation.collectorName") }} : {{ item.nome_cobrador_guia }}</pre>
            <br />

            <pre>{{ $t("operation.tripInfo") }}</pre>
            <br />
            <pre>{{ $t("operation.tripStart") }} : {{ item.inicio_viagem }}</pre>
            <br />
            <pre>{{ $t("operation.scheduledStart") }} : {{ item.horario_saida_previsto }}</pre>
            <br />
            <pre>{{ $t("operation.scheduledArrival") }} : {{ item.horario_chegada_previsto }}</pre>
            <br />
            <pre>{{ $t("operation.openingType") }} : {{ item.tipo_abertura }}</pre>
            <br />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="showingDrawerLinhasSelecionadas" absolute temporary overlay-opacity="0" right dark
      style="width: 40%; z-index: 5000">
      <template v-if="drawerLinhasSelecionadasMounted">
      <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
        <v-text-field v-model="searchLinhasSelecionadas" append-icon="mdi-magnify" :label="$t('operation.searchLine')"
          single-line hide-details></v-text-field>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel v-for="item in filteredLinhasSelecionadas" :key="`DRAWER-L-${item.id_linha}`">
          <v-expansion-panel-header class="font-weight-bold" style="color: grey">
            <v-chip :color="item.color">
              {{ item.nome_linha }}
            </v-chip>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <pre>{{ $t('operation.lineCode') }} : {{ item.cod_linha }}</pre>
            <br />
            <pre>{{ $tc('unit.self', 1) }} : {{ item.descricao_unidade }}</pre>
            <br />
            <pre>{{ $tc('company.self', 1) }} : {{ item.razao_social }}</pre>
            <br />
            <pre>{{ $t('operation.circular') }} : {{ item.circular_extenso }}</pre>
            <br />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="showingDrawerPontosInteresse" absolute temporary overlay-opacity="0" right dark
      style="width: 40%; z-index: 5000">
      <template v-if="drawerPontosInteresseMounted">
      <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
        <v-text-field v-model="searchPontosInteresse" append-icon="mdi-magnify" :label="$t('operation.searchPoi')"
          single-line hide-details></v-text-field>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel v-for="item in filteredPontosInteresse" :key="`POI-${item.id_cerca}`"
          @click="pontoInteresseClicked(item)">
          <v-expansion-panel-header class="font-weight-bold" style="color: grey">
            <v-chip :color="item.color">
              {{ item.nome_cerca }}
            </v-chip>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <pre>{{ $t('geofence.code') }} : {{ item.cod_cerca }}</pre>
            <br />
            <pre>{{ $t('person.name') }} : {{ item.nome_cerca }}</pre>
            <br />
            <pre>{{ $tc('address.self', 1) }} : {{ item.endereco }}</pre>
            <br />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      </template>
    </v-navigation-drawer>

    <!-- Dialog Status de veiculos-->
    <v-dialog v-model="dialogStatusVeiculos" fullscreen max-width="100%" style="z-index: 8000">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeStatusVeiculos">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('operation.statusVehiclesTitle') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <merus-data-table :headers="headersStatusVeiculosWithProperties" :items="filteredItemsStatusVeiculos"
              sort-by="cod_veiculo" dense class="elevation-7" locale="pt" :loading="loadingStatusVeiculos"
              :loading-text="$t('system.messages.loading')" style="border-radius: 10px"
              virtualize-rows
              @update:displayedItems="displayedItemsForExportStatusVeiculos = $event">
              <template v-slot:toolbar>
                <CadastroToolbar :title="tituloStatusVeiculos" :token="token"
                  :items="displayedItemsForExportStatusVeiculos !== null ? displayedItemsForExportStatusVeiculos : filteredItemsStatusVeiculos"
                  csv-title="statusveiculos" :csv-headers="headersStatusVeiculos" :pdf-title="tituloStatusVeiculos" :pdf-headers="headersStatusVeiculos"
                  pdf-filename="statusveiculos" hide-search />
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" color="blue" @click="showUltimasPosicoesVeiculo(item)"
                  :disabled="!item.dt_ultima_posicao">mdi-map-marker-multiple</v-icon>
              </template>
            </merus-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUltimasPosicoesVeiculo" width="80%" @close="closeUltimasPosicoesVeiculo">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <strong>{{ $t('operation.lastPosition') }}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon dark @click="closeUltimasPosicoesVeiculo">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <merus-data-table :headers="headersUltimasPosicoesVeiculoWithProperties" :items="ultimasPosicoesVeiculo" dense
            class="elevation-7" locale="pt" :loading="loadingUltimasPosicoesVeiculo"
            :loading-text="$t('system.messages.loading')" :item-class="getColorPosicao"
            style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;">
          </merus-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmResetDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ this.mensagemResetDialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmResetDialog = false">{{ $t('button.cancel')
          }}</v-btn>
          <v-btn color="red accent-4" class="white--text" @click="resetNotificacao()">{{ $t('button.confirmOk')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Diário de Bordo -->
    <v-dialog v-model="dialogDiarioBordo" fullscreen max-width="100%" style="z-index: 8000">
      <v-dialog v-model="dialogEditEntrada" max-width="80%">
        <v-card>
          <v-card-title>{{ $t('operation.editEntry') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="itemDiario.observacoes" :label="$t('area.observations')" auto-grow clearable
                  counter rows="1"
                  :rules="[(v) => (v === null || v.length <= 1000) || $t('rules.message1000')]"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="closeEditEntrada">{{ $t('button.cancel') }}</v-btn>
            <v-btn color="primary" dark @click="saveEntrada">{{ $t('button.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteEntrada" max-width="80%">
        <v-card>
          <v-card-title class="headline">
            <span style="color: #d60000">{{ $t('system.alert') }}</span>
          </v-card-title>
          <v-card-text>
            <span style="color: #d60000">{{ $t('operation.confirmDeleteEntry') }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-4" class="white--text" @click="closeDeleteEntrada">{{ $t('button.cancel')
            }}</v-btn>
            <v-btn color="red accent-4" class="white--text" @click="confirmDeleteEntrada">{{ $t('button.confirmOk')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDiarioBordo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('nav.registration.logbook') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-form ref="diarioForm">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete v-model="itemDiario.id_tipo_entrada_diario" :items="tiposEntradaDiario"
                    item-text="descricao_tipo_entrada" item-value="id_tipo_entrada_diario" clearable
                    :label="$t('operation.type')" :rules="[(v) => !!v || $t('rules.messageType')]"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete v-model="itemDiario.id_motivo" :items="motivos" item-text="descricao_motivo"
                    item-value="id_motivo" clearable :label="$t('operation.reason')"
                    :rules="[(v) => !!v || $t('rules.messageReason')]"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-datetime-picker :label="$t('operation.entryDate')" v-model="dtEntradaDiario"
                    :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                    date-format="dd/MM/yyyy" :clear-text="$t('button.close')"
                    :rules="[(v) => !!v || $t('rules.messageDate')]">
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete v-model="diarioLinhas" :items="linhas" item-text="nome_linha" item-value="id_linha"
                    clearable multiple :label="$tc('line.self', 1)" @change="onLinhaDiarioChanged"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete v-model="diarioVeiculos" :items="veiculos" item-text="numero_ordem"
                    item-value="id_veiculo" clearable multiple :label="$tc('vehicle.self', 1)"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete v-model="diarioViagens" :items="viagens" item-text="descricao_viagem"
                    item-value="id_viagem" clearable multiple :label="$tc('trip.self', 1)"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="10" md="10">
                  <v-textarea v-model="itemDiario.observacoes" :label="$t('area.observations')" auto-grow clearable
                    counter rows="1"
                    :rules="[(v) => (v === null || v.length <= 1000) || $t('rules.message1000')]"></v-textarea>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-btn color="primary" dark small class="mb-2" fab @click="saveEntrada">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-container>

            <merus-data-table :headers="headersDiarioWithProperties" :items="entradasDiario" sort-by="dt_entrada" dense
              class="elevation-7" locale="pt" :loading="loadingDiario" show-expand :single-expand="true"
              item-key="id_entrada_diario" :loading-text="$t('system.messages.loading')" style="border-radius: 10px">
              <template v-slot:expanded-item="{ item }">
                <div style="width: 100%; padding: 5px;">
                  <v-simple-table dense style="width: 100%;">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>{{ $tc('line.self', 2) }}</th>
                          <th>{{ $tc('vehicle.self', 2) }}</th>
                          <th>{{ $tc('trip.self', 2) }}</th>
                          <th>{{ $t('operation.registeredBy') }}</th>
                          <th>{{ $t('operation.editedBy') }}</th>
                          <th>{{ $t('operation.editedAt') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ item.linhas }}</td>
                          <td>{{ item.veiculos }}</td>
                          <td>{{ item.viagens_realizadas }}</td>
                          <td>{{ item.usuario_inclusao }}</td>
                          <td>{{ item.usuario_edicao }}</td>
                          <td>{{ item.dt_edicao }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editEntrada(item)">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteEntrada(item)">mdi-delete</v-icon>
              </template>
            </merus-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog - Grid de Status Validador GPS -->
    <v-dialog v-model="dialogGridStatus" fullscreen max-width="100%" style="z-index: 8000">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeGridStatus">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('operation.gridStatusTitle') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text style="margin-top: 10px">
          <v-form>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete v-model="idEmpresaSelected" :items="empresasSelect" item-text="razao_social"
                  item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                  @change="empresasSelectChanged"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha"
                  item-value="id_linha" clearable :label="$tc('line.self', 1)"
                  @change="linhasSelectChanged"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete v-model="idVeiculoSelected" :items="veiculosSelect" item-text="cod_veiculo"
                  item-value="id_veiculo" clearable :label="$tc('vehicle.self', 1)"></v-autocomplete>
              </v-col>
              <v-row>
                <v-col cols="12" sm="10" md="4" style="min-width: fit-content; margin-left: 5px;">
                  <v-datetime-picker :label="$t('datetime.startDate')" v-model="dtiniciobase"
                    :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                    date-format="dd/MM/yyyy" :clear-text="$t('button.close')" ref="inputDtInicioBase"
                    :rules="[dtiniciobaseRules]">
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>

                <!-- <v-col cols="12" sm="1" md="1"></v-col> -->

                <v-col cols="1" sm="1" md="1" style="min-width: fit-content;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                        @click="filtroGridStatus">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('operation.search') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                        @click="limparFiltrosGridStatus" style="margin-left: 10px">
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('operation.newConsult') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-row>
          </v-form>
          <div id="tablecontainer">
            <merus-data-table :headers="headersGridStatusWithProperties" :items="itensGridStatus"
              :loading="loadinggridstatus" :loading-text="$t('system.messages.loading')" sort-by="cod_veiculo" dense
              class="elevation-7" locale="pt" style="border-radius: 10px" :options="{ itemsPerPage: 10 }"
              virtualize-rows
              @update:displayedItems="displayedItemsForExportGridStatus = $event">
              <template v-slot:toolbar>
                <CadastroToolbar :title="$t('operation.gridStatusTitle')" :token="token"
                  :items="displayedItemsForExportGridStatus !== null ? displayedItemsForExportGridStatus : itensGridStatus"
                  csv-title="gridstatus" :csv-headers="headersGridStatus" :pdf-title="$t('operation.gridStatusTitle')" :pdf-headers="headersGridStatus"
                  pdf-filename="gridstatusvalgps" hide-search />
              </template>
            </merus-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Quadro sinótico -->
    <v-dialog v-model="dialogSinotico" max-width="70%" :loading="sinoticoLoading" style="z-index: 9000" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeQuadroSinotico">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ sinoticoTitle }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="margin-top: 5px">
          <div v-if="sinoticoLoading" style="
              display: block;
              width: 50%;
              height: 100%;
              text-align: center;
              margin: auto;
              padding: 2px;
            ">
            <v-progress-circular :size="100" :width="10" color="primary" indeterminate></v-progress-circular>
          </div>
          <div v-if="!sinoticoLoading && dialogSinotico">
            <SinoticoComponent :key="keySinoticoIda" :veiculos="veiculosLinhaSinoticoIda" :rota="rotaIda"
              :pontos-principais="pontosPrincipaisSinotico" :pontos-interesse="pontosInteresseSinotico" color="green"
              :tile="$t('operation.go')"></SinoticoComponent>
            <SinoticoComponent :key="keySinoticoVolta" :veiculos="veiculosLinhaSinoticoVolta" :rota="rotaVolta"
              :pontos-principais="pontosPrincipaisSinotico" :pontos-interesse="pontosInteresseSinotico" color="orange"
              :tile="$t('operation.back')"></SinoticoComponent>
          </div>
        </v-card-text>
      </v-card>

    </v-dialog>

    <!-- DIV do mapa e da toolbar de botões -->
    <div v-if="pageLoaded" style="width: 100%; height: 81vh; float: left; padding-right: 5px">
      <v-toolbar flat color="blue-grey lighten-4" style="border-radius: 10px; margin-top: 5px">
        <v-autocomplete v-model="veiculosStandAloneSelected" :items="veiculosStandAlone" item-text="display"
          item-value="display" :item-disabled="item => item.isSeparator"
          menu-props="{ maxHeight: 'auto', overflowY: true }" clearable rounded single-line solo multiple
          :label="$t('operation.selectOneOrMoreVehiclesUnities')" style="margin-top: 22px; margin-right: 10px"
          @change="veiculoStandAloneChanged">
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggleAllVeiculos">
              <v-list-item-action>
                <v-icon :color="veiculosStandAloneSelected.length > 0 ? 'indigo darken-4' : ''">
                  {{ selectIcon(veiculosStandAloneSelected, veiculosStandAlone) }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('operation.all') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template v-slot:item="{ item, attrs, on }">
            <template v-if="item.isSeparator">
              <v-divider class="mt-2 mb-2"></v-divider>
              <v-list-item v-bind="attrs" style="min-height: auto; pointer-events: none;">
                <v-list-item-content style="padding: 0;">
                  <v-list-item-title style="color: black; font-size: 0.875rem;">
                    {{ item.display }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2 mb-2"></v-divider>
            </template>
            <template v-else>
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-action>
                  <v-checkbox :input-value="veiculosStandAloneSelected.includes(item.display)" color="primary"
                    hide-details></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.display }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>

          <template v-slot:selection="{ item, index }">
            <span v-if="index <= 4" style="margin-right: 5px;">{{ typeof item === 'string' ? item : item.display || item
              }}</span>
            <v-chip v-if="index === 5" class="grey--text text-caption">
              <span>(+{{ veiculosStandAloneSelected.length - 5 }} {{ $t('operation.others') }})</span>
            </v-chip>
          </template>
        </v-autocomplete>
        <BuscaEndereco style="max-width: 30%; margin-top: 22px;" @search="(local) => plotarEndereco(local)"
          @clear="limparEndereco()"></BuscaEndereco>
        <v-btn color="primary" dark rounded large @click="openQuadroViagens"
          style="margin-left: 10px; margin-bottom: 8px;">
          <v-icon style="margin-right: 5px;">mdi-billboard</v-icon>
          <span>{{ $tc('trip.self', 2) }}</span>
        </v-btn>
      </v-toolbar>

      <l-map ref="map" :zoom="zoom" :center="center" :minZoom="minZoom" :maxZoom="maxZoom" @update:center="centerUpdate"
        @update:zoom="zoomUpdate" :options="mapOptions" style="border-radius: 10px; margin-top: 5px; z-index: 1">
        <l-tile-layer :url="url" :attribution="attribution" />


        <!-- Áreas de Planejamento: camada opcional, independente da linha selecionada. -->
        <l-control v-if="areasMapaDisponivel" :position="'topright'" class="text-overlay">
          <div class="d-flex align-center">
            <v-checkbox v-model="showPolygonMapaOperacao" :label="$t('operation.planningAreas')" hide-details
              class="mt-0 pt-0" :loading="loadingAreasMapa"></v-checkbox>
            <v-chip v-if="showPolygonMapaOperacao && areasMapa.some((a) => Number(a.zona_risco) === 1)" x-small
              class="ml-2" color="red darken-2" text-color="white">
              <v-icon x-small left>{{ iconeZonaRisco }}</v-icon>{{ $t('area.riskZone') }}
            </v-chip>
          </div>
        </l-control>

        <l-control :position="'topright'" class="text-overlay">
          <v-row v-if="showRotaVisible">
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-if="showRotaVisible" v-model="showRota" :label="$t('operation.route')"
                @change="showRotaChanged"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-if="showRotaVisible" v-model="showCercasMapaOperacao"
                :label="$tc('geofence.self', 1)"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-if="showRotaVisible" v-model="markerPontosInteresseVisible"
                :label="$t('operation.pois')"></v-checkbox>
            </v-col>
          </v-row>
        </l-control>

        <l-control :position="'topright'" class="text-overlay">
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-checkbox v-if="showRotaVisible" v-model="showIda" :label="$t('operation.go')"
                @change="sentidoFiltered"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-checkbox v-if="showRotaVisible" v-model="showVolta" :label="$t('operation.back')"
                @change="sentidoFiltered"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox v-if="showRotaVisible" v-model="showDeslocamento" :label="$t('operation.deadhead')"
                @change="sentidoFiltered"></v-checkbox>
            </v-col>
          </v-row>
        </l-control>

        <l-control :position="'topright'" v-if="setup.has_condicao_climatica === 1">
          <v-menu offset-y rounded>
            <template v-slot:activator="{ on }" style="z-index: 2;">
              <v-chip v-on="on" dark>
                <v-icon style="margin-right: 5px;" :color="weatherColor">{{ weatherIcon }}</v-icon>
                <strong style="margin-right: 5px;">{{ weatherTemperature }}° C</strong>
                <span style="margin-right: 5px;">{{ weatherCityName }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-chip>
            </template>
            <v-list>
              <v-list-item v-for="(item, key) in cidades" :key="`WEATHER-${key}`" @click="weatherCityChanged(item)">
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </l-control>

        <l-control :position="'topright'">
          <v-btn small fab @click="showDrawer">
            <v-icon color="black">mdi-bus</v-icon></v-btn>
        </l-control>
        <l-control :position="'topright'">
          <v-btn small fab @click="showDrawerLinhasSelecionadas">
            <v-icon color="black">mdi-line-scan</v-icon></v-btn>
        </l-control>
        <l-control :position="'topleft'">
          <v-btn small fab @click="showDrawerLinhas">
            <v-icon color="black">mdi-chevron-right</v-icon></v-btn>
        </l-control>
        <l-control :position="'topleft'">
          <v-btn small fab @click="openDiarioBordo">
            <v-icon color="black">mdi-notebook</v-icon></v-btn>
        </l-control>
        <l-control :position="'topright'">
          <v-btn small fab @click="showDrawerPontosInteresse">
            <v-icon color="black">mdi-google-maps</v-icon></v-btn>
        </l-control>

        <l-geo-json v-for="rota in rotas" :key="`${rota.id_linha}-${rota.id_rota}`" :geojson="rota.geojson"
          :options-style="rota.style" :options="rota.options" :visible="rotasVisiveis.has(rota.id_rota) && showRota">
        </l-geo-json>

        <l-geo-json v-for="cerca in cercasComunsGeoJson" :key="`CERCA-${cerca.id_cerca}`"
          :geojson="cerca.geojson" :options="cerca.options" :options-style="cerca.style"
          :visible="showCercasMapaOperacao">
        </l-geo-json>

        <l-circle v-for="cerca in cercasComunsCirculares" :key="`POI-${cerca.id_cerca}`"
          :radius="cerca.raio || raioCercaPadrao" :lat-lng="latLng(cerca.lat_centro, cerca.lng_centro)"
          :visible="showCercasMapaOperacao" color="red" fill-color="red"></l-circle>

        <l-marker v-for="reg in cercasComuns" :key="`MARCADOR-${reg.id_cerca}`"
          :visible="showMarkerCerca(reg.codigo_cerca)" :lat-lng="latLng(reg.lat_centro, reg.lng_centro)"
          :icon="getIconPontosLinha()">
          <l-popup :options="{ maxWidth: 300 }">
            {{ reg.nome_cerca }}
          </l-popup>
        </l-marker>

        <!-- <l-polygon
          :visible="showCercaMapaOperacao"
          :lat-lngs="cercaMapaOperacao.latlngs"
          :color="cercaMapaOperacao.color"
        ></l-polygon> -->

        <Vue2LeafletRotatedMarker v-for="reg in filteredVeiculosLinha" :key="reg.id_veiculo"
          :lat-lng="latLng(reg.lat, reg.lng)" :visible="isMarkerVisible(reg)" :icon="getIcon(reg)"
          :rotationAngle="parseInt(reg.rumo)" :rotationOrigin="'15px 15px'">
          <l-popup :options="{ maxWidth: 'fit-content' }">
            <pre><b>{{ $t('vehicle.code') }} :</b> {{ reg.cod_veiculo }}</pre>
            <pre v-if="showInfoValidador"><b>{{ $t('operation.validatorLine') }} :</b> {{ reg.nome_linha }}</pre>
            <pre v-if="showInfoValidador"><b>{{ $t('operation.driverValidator') }} :</b> {{ reg.matricula_motorista ?
              `(${reg.matricula_motorista}) ${reg.nome_motorista || ''}` : '' }}</pre>
            <pre v-if="showInfoValidador"><b>{{ $t('operation.collectorValidator') }} :</b> {{ reg.matricula_cobrador ?
              `(${reg.matricula_cobrador}) ${reg.nome_cobrador ||
              ''}` : '' }}</pre>
            <br />
            <pre v-if="hasGuias"><b>{{ ordemDeServico }} :</b> {{ reg.numero_guia }}</pre>
            <pre v-if="hasGuias"><b>{{ $t('operation.openingDate') }} :</b> {{ reg.dt_abertura_extenso }}</pre>
            <pre v-if="hasGuias"><b>{{ $t('operation.pickupTime') }} :</b> {{ reg.dt_pegada_extenso }}</pre>
            <pre v-if="hasGuias"><b>{{ $t('guide.escalation') }} :</b> {{ reg.escalonamento }}</pre>
            <pre v-if="hasGuias"><b>{{ $tc('line.self', 1) }} :</b> {{ reg.nome_linha_guia }}</pre>
            <pre v-if="hasGuias"><b>{{ $t('guide.employee.motorist') }} :</b> {{ reg.matricula_motorista_guia ?
              `(${reg.matricula_motorista_guia}) ` +
              `${reg.nome_motorista_guia || ''}` : '' }}</pre>
            <pre v-if="hasGuias && isUrbano"><b>{{ $t('guide.employee.collector') }} :</b> {{ reg.matricula_cobrador_guia ?
              `(${reg.matricula_cobrador_guia})
          ${reg.nome_cobrador_guia || 'ß'}` : '' }}</pre>
            <pre v-if="isUrbano"><b>{{ $tc('turnstile.self', 1) }} :</b> {{ reg.roleta }}</pre>
            <br />
            <pre><b>{{ $t('operation.lastPositionDate') }} :</b> {{ reg.dt_gps }}</pre>
            <pre><b>{{ $t('operation.speed') }} :</b> {{ reg.velocidade }} km/h</pre>
            <br />
            <pre><b>{{ $t('operation.tripStart') }} :</b> {{ reg.inicio_viagem }}</pre>
            <pre><b>{{ $t('operation.scheduledStart') }} :</b> {{ reg.horario_saida_previsto }}</pre>
            <pre><b>{{ $t('operation.scheduledArrival') }} :</b> {{ reg.horario_chegada_previsto }}</pre>
            <pre><b>{{ $t('operation.openingType') }} :</b> {{ reg.tipo_abertura }}</pre>
            <pre><b>{{ $t('operation.lineStatus') }} :</b> {{ reg.status_linha }}</pre>
            <pre v-if="setup.has_controle_embarque"><b>{{ $t('operation.occupancy') }}: </b>{{ reg.ocupacao }}</pre>
            <pre v-if="setup.has_controle_embarque"><b>{{ $t('operation.occupancyRate') }} :</b> {{ reg.taxa_ocupacao }}%
            </pre>
            <pre v-if="setup.has_eta"><b>{{ $t('operation.nextStop') }}: </b>{{ reg.nome_cerca_proxima_parada }}</pre>
            <pre v-if="setup.has_eta"><b>{{ $t('operation.eta') }}: </b>{{ getEtaFormatted(reg.eta_segundos_proxima_parada)
            }}</pre>
            <pre v-if="setup.has_eta"><b>{{ $t('operation.etaArrival') }}: </b>{{
              getEtaFormatted(reg.eta_segundos_parada_final)
          }}</pre>
            <template v-if="getVeiculoPopupTrackerFields(reg).length">
              <br />
              <pre v-for="field in getVeiculoPopupTrackerFields(reg)" :key="field.id"><b>{{ $t(field.labelKey) }}</b> {{ formatVeiculoPopupTrackerField(reg, field) }}</pre>
            </template>
          </l-popup>
          <l-tooltip :content="reg.cod_veiculo"
            :options="{ permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }"></l-tooltip>
        </Vue2LeafletRotatedMarker>

        <l-geo-json v-for="poi in pontosInteresseGeoJson" :key="`POI-${poi.id_cerca}`" :geojson="poi.geojson"
          :options="poi.options" :options-style="poi.style" :visible="markerPontosInteresseVisible">
        </l-geo-json>

        <l-circle v-for="poi in pontosInteresseCirculares" :key="`POI-CIRC-${poi.id_cerca}`"
          :radius="poi.raio || raioCercaPadrao" :lat-lng="latLng(poi.lat_centro, poi.lng_centro)"
          :visible="markerPontosInteresseVisible"></l-circle>

        <l-marker v-for="r in pontosInteresse" :key="`POI-MARCADOR-${r.id_cerca}`"
          :lat-lng="latLng(r.lat_centro, r.lng_centro)" :visible="markerPontosInteresseVisible">
          <l-popup :options="{ maxWidth: 'fit-content' }">
            <pre>{{ $tc('geofence.self', 1) }} : {{ r.nome_cerca }}</pre>
            <pre>{{ $t('operation.type') }} : {{ r.descricao_tipo_cerca }}</pre>
            <pre>{{ $tc('address.self', 1) }} : {{ r.endereco }}</pre>
          </l-popup>
          <l-tooltip :content="r.nome_cerca"
            :options="{ permanent: true, direction: 'right', opacity: 1.0, className: 'cerca__tooltip' }"></l-tooltip>
        </l-marker>

        <l-control :position="'bottomleft'" v-if="filtersBreadcrumbs.length !== 0">
          <v-chip dark @click="filtersBreadcrumbsClicked">
            <v-btn icon dark @click.stop="closeBreadcrumbs">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-breadcrumbs :items="filtersBreadcrumbs">
            </v-breadcrumbs>
          </v-chip>
        </l-control>
      </l-map>
    </div>


    <!--- Dialog de progresso de processos -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="progressoDialog" persistent max-width="500" style="height: 300px; z-index: 90000">
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular :size="50" :width="5" color="primary" indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<style>
.text-overlay {
  background: #fff;
  padding: 0 0.5em;
  border: 1px solid #aaa;
  border-radius: 0.1em;
}

#tablecontainer {
  width: 100%;
  height: 68vh;
  display: inline-block;
  position: relative;
}

#mapcontainer {
  width: 100%;
}

html::-webkit-scrollbar {
  display: none;
}

html {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.v-progress-linear__content {
  flex-direction: row !important;
  justify-content: flex-start !important;
}

.blink {
  animation: blink .2s infinite alternate;
}

.veiculo__tooltip {
  background-color: white;
  color: black;
  border: none;
  font-size: x-small;
  font-weight: bold;
  padding: 3px;
}

.cerca__tooltip {
  background-color: #4a4a4a;
  color: white;
  border: none;
  font-size: x-small;
  font-weight: bold;
  padding: 3px;
}

.notification__container {
  position: fixed;
  bottom: 10px;
  right: 10px;
  display: grid;
  grid-gap: 0.5em;
  z-index: 2500;
  width: 20%;
}

@keyframes blink {
  from {
    opacity: 0;
  }
}

.item__com__problema {
  color: #C62828;
  font-weight: bold;
}
</style>

<script>
import apiController from "@/utils/apiController";
import axios from "axios";
import { LineColors, modo } from "@/constants";
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LTooltip,
  LGeoJson,
  LCircle
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import DateUtils from "../utils/dateutils";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import { mapGetters, mapMutations } from "vuex";
import EventBus from "@/utils/eventBus";

import SinoticoComponent from "./SinoticoComponent.vue";
import QuadroViagens from './QuadroViagens.vue';
import BuscaEndereco from "./TextFields/BuscaEndereco.vue";
import translateDbField from "@/utils/translateDbField";
import { notificacaoPertenceAoUsuario } from "@/utils/notificacaoVisibilidade";
import { camadaDaArea, ICONE_ZONA_RISCO } from "@/utils/areasMapa";
import { getVeiculoCor, isVeiculoVisibleOnMap, createVeiculoOperacaoMapIcon, resolveVeiculoStatus } from "@/utils/veiculoStatusOperacao";

const ICON_PONTOS_LINHA = L.divIcon({
  className: "my-custom-pin",
  html: `<svg width="32px" height="32px" viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/">
        <g transform="translate(0 -1028.4)">
          <path d="m12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z" transform="translate(0 1028.4)" fill="#e74c3c"/>
          <path d="m12 3c-2.7614 0-5 2.2386-5 5 0 2.761 2.2386 5 5 5 2.761 0 5-2.239 5-5 0-2.7614-2.239-5-5-5zm0 2c1.657 0 3 1.3431 3 3s-1.343 3-3 3-3-1.3431-3-3 1.343-3 3-3z" transform="translate(0 1028.4)" fill="#c0392b"/>
        </g>
        </svg>`,
  iconAnchor: [16, 32]
});

const DEFAULT_MAP_CENTER = L.latLng(19.432821, -99.133208);

export default {
  name: "RastreamentoMain",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControl,
    LTooltip,
    LGeoJson,
    LCircle,
    MerusDataTable,
    CadastroToolbar,
    Vue2LeafletRotatedMarker,
    SinoticoComponent,
    QuadroViagens,
    BuscaEndereco,
  },
  data: () => ({
    displayedItemsForExportStatusVeiculos: null,
    displayedItemsForExportGridStatus: null,
    user: null,
    id_usuario: null,
    token: null,
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    search: "",
    searchCarros: "",
    searchEndereco: "",
    searchPontosInteresse: "",
    showGridViagens: false,
    quadroViagensMounted: false,
    drawerVeiculosMounted: false,
    drawerLinhasSelecionadasMounted: false,
    drawerPontosInteresseMounted: false,
    dialogGridStatus: false,
    dialogStatusVeiculos: false,
    selectedItem: -1,
    selectedUnidade: -1,
    notificationDialog: false,
    showRotaVisible: false,
    showIda: true,
    showVolta: true,
    showDeslocamento: false,
    replayDialog: false,
    confirmResetDialog: false,
    loadingnotificacoes: false,
    loadinggridstatus: false,
    mensagemResetDialog: "",
    veiculos: [],
    veiculosLinha: [],
    filteredVeiculosLinha: [],
    veiculoPopupFieldsByTracker: {
      'database.trackerManufacturers.avlQueclink': [
        { id: 'status_canbus', labelKey: 'equipStatus.statusCan', formatter: 'formatStatusCanbus' },
        { id: 'status_ignicao', labelKey: 'equipStatus.statusIgnition', formatter: 'formatStatusIgnicao' },
      ],
    },
    linhas: [],
    marcadores: [],
    veiculosStandAloneSelected: [],
    searchLinhasSelecionadas: "",
    showingDrawerLinhasSelecionadas: false,
    showingDrawerPontosInteresse: false,
    filters: [],
    statusFilters: [],
    nomerota: "",
    zoom: 12,
    minZoom: 5,
    maxZoom: 18,
    loadingPage: false,
    progressoDialog: false,
    mensagemProgressoDialog: "",
    markerPontosInteresseVisible: false,
    pageLoaded: false,
    pollingActive: true,
    pollingCancelSource: null,
    markerVeiculosVisible: false,
    iconSize: [32, 32],
    iconSizeStops: [32, 32],
    tratadaSelected: null,
    mapOptions: {
      zoomSnap: 0.5,
    },
    rotas: [],
    polyline: {
      latlngs: [],
      color: "red",
    },
    areasMapa: [],
    areasMapaCarregadas: false,
    areasMapaDisponivel: true,
    loadingAreasMapa: false,
    iconeZonaRisco: ICONE_ZONA_RISCO,
    cercaMapaOperacao: {
      id_linha: null,
      latlngs: [],
      color: "yellow",
      fillColor: "#232323",
    },
    currentLineColor: 0,
    showRota: false,
    tituloStatusVeiculos: "",
    showingDrawer: false,
    showingDrawerLinhas: false,
    idEmpresaSelected: null,
    empresasPermitidas: [],
    empresasSelect: [],
    idLinhaSelected: null,
    linhasSelect: [],
    idVeiculoSelected: null,
    veiculosSelect: [],
    posicoesCarro: [],
    timeProps: {
      useSeconds: true,
    },
    dtiniciobase: null,
    itensGridStatus: [],
    notificacoes: [],
    idnotificacaoreset: null,
    notifToReset: null,
    loadingStatusVeiculos: false,
    linhasSelecionadas: [],
    linhaClicked: null,
    nomeLinhaClicked: null,
    shapeClicked: null,
    shapeAreaClicked: null,
    showPolygonMapaOperacao: false,
    showCercasMapaOperacao: false,
    showCercaMapaOperacao: false,
    markerStandAloneClicked: false,
    posicaoMarkerClicked: [
      {
        id_carro: "",
        cod_veiculo: "",
        dt_posicao: "",
        dt_posicao_extenso: "",
        lat: "",
        lng: "",
        rumo: "",
        velocidade: "",
      }],
    totalnotificacoes: [{ total: 0 }],
    totalnotificacoesanterior: null,
    configLoading: false,
    pontosInteresse: [],
    pontosInteresseGeoJson: [],
    pontosInteresseCirculares: [],
    pontosInteresseSinotico: [],
    cercas: [],
    permissoes: [],
    recursos: [],
    showProgressEndereco: false,
    veiculosStatusVeiculos: [],
    statusVeiculosOperacao: [],
    dialogSinotico: false,
    linhaSelecionada: null,
    distIdaLinha: 0,
    distVoltaLinha: 0,
    posicoesSinotico: [],
    veiculosLinhaSinoticoIda: [],
    veiculosLinhaSinoticoVolta: [],
    sinoticoLoading: false,
    unidades: [],
    filtersBreadcrumbs: [],
    veiculoClicked: null,
    indexPosicaoClicked: null,
    ultimaPosicaoClicked: null,
    notificacoesImportantes: [],
    notificacoesImportantesVisiveis: [],
    dataInicialNotificacoes: null,
    notifClicked: null,
    key: 0,
    dialogMapaNotificacao: false,
    itemEndereco: {
      street: "",
      houseNumber: "",
      district: "",
      city: "",
      stateCode: "",
      postalCode: "",
    },
    weatherColor: null,
    weatherIcon: null,
    weatherCitySelected: null,
    weatherDate: null,
    weatherTemperature: null,
    weatherCityName: null,
    weatherConditions: [],
    cidades: [],
    dialogDiarioBordo: false,
    itemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_linha: null,
      id_veiculo: null,
      id_viagem: null,
      dt_entrada: null,
      id_usuario_inclusao: null,
      observacoes: null
    },
    defaultItemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_linha: null,
      id_veiculo: null,
      id_viagem: null,
      dt_entrada: null,
      id_usuario_inclusao: null,
      observacoes: null
    },
    entradasDiario: [],
    tiposEntradaDiario: [],
    motivos: [],
    viagens: [],
    dtEntradaDiario: null,
    loadingDiario: false,
    diarioForm: null,
    diarioLinhas: [],
    diarioVeiculos: [],
    diarioViagens: [],
    loadingEndereco: false,
    searchMarkerPos: {
      lat: null,
      lgn: null
    },
    closeAlertFunction: null,
    rotaIda: null,
    rotaVolta: null,
    pontosPrincipaisSinotico: [],
    keySinoticoIda: 0,
    keySinoticoVolta: 2,
    editingDiario: false,
    dialogEditEntrada: false,
    dialogDeleteEntrada: false,
    setup: {
      id_modo: null,
      descricao_modo: null,
      has_eta: 0,
      has_google_chat: 0,
      has_validador: 0,
      has_controle_embarque: 0,
      has_comunicacao: 0,
      has_subsidio: 0,
      has_condicao_climatica: 0
    },
    loadingUltimasPosicoesVeiculo: false,
    ultimasPosicoesVeiculo: [],
    dialogUltimasPosicoesVeiculo: false,
    center: null,
    /** Quantidade máxima de alertas exibidos no card (vem da config; default até a API responder) */
    limiteAlertasTela: 3,
    config: null,
    filtrosExpanded: false,
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
  }),
  props: [],
  async created() {
    this.map = null;
    this.searchMarker = null;
    this.markersNotif = [];
    this.currentZoom = 12;
    this.currentCenter = [19.432821, -99.133208];
    this._latLngCache = new Map();
    this._iconCache = new Map();
    this._beepAudio = null;
    this._unidadesLoaded = false;
    this._batchingFilteredVeiculos = false;
    this._pendingFilteredVeiculosLinha = null;
    this._onConfigUpdated = null;

    this.id_usuario = JSON.parse(sessionStorage.getItem("user")).id_usuario;
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.permissoes = JSON.parse(sessionStorage.getItem("permissoes"));
    this.dataInicialNotificacoes = new Date();
    await this.populaSetup();
    this.initialize();
    this.getConfig();
    this.populaStatusVeiculosOperacao();
  },
  mounted() {
    // Initialize the platform object:
    // Listener para recarregar configurações quando forem atualizadas
    this._onConfigUpdated = () => {
      if (!this.isPollingActive()) return;
      this.getConfig().then(() => {
        if (!this.isPollingActive()) return;
      });
      this.populaStatusVeiculosOperacao();
    };
    this._onAbrirMapaNotificacao = (payload) => {
      if (!payload || !payload.notif) {
        return;
      }
      this.openMapaNotificacao(payload.notif, payload.color);
    };
    this._onNotificacaoTratada = (idNotificacao) => {
      if (idNotificacao == null || !this.markersNotif) {
        return;
      }
      const notifMarker = this.markersNotif.findIndex((m) => m.id_notif === idNotificacao);
      if (notifMarker !== -1 && this.map) {
        this.map.removeLayer(this.markersNotif[notifMarker].marker);
        this.markersNotif.splice(notifMarker, 1);
      }
    };
    EventBus.$on('config-updated', this._onConfigUpdated);
    EventBus.$on('operacao-notificacao-abrir-mapa', this._onAbrirMapaNotificacao);
    EventBus.$on('operacao-notificacao-tratada', this._onNotificacaoTratada);
  },
  beforeDestroy() {
    this.removerCamadaAreas();
    this.pollingActive = false;
    this.cancelPollingRequests();
    if (this._onConfigUpdated) {
      EventBus.$off('config-updated', this._onConfigUpdated);
    }
    if (this._onAbrirMapaNotificacao) {
      EventBus.$off('operacao-notificacao-abrir-mapa', this._onAbrirMapaNotificacao);
    }
    if (this._onNotificacaoTratada) {
      EventBus.$off('operacao-notificacao-tratada', this._onNotificacaoTratada);
    }
    this.resetNotif(null);
    this.resetLinhas(null);
    this.resetVeiculos(null);
    this.resetTempo(null);
  },
  watch: {
    showPolygonMapaOperacao(ativo) {
      if (ativo) this.mostrarAreasMapa();
      else this.removerCamadaAreas();
    },
    '$route.query.relatorio'(val) {
      if (val === 'gridstatus') {
        if (!this.dialogGridStatus) this.showGridStatus();
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.diarioForm) {
        this.$refs.diarioForm.resetValidation();
      }
    }
  },
  computed: {
    headersUltimasPosicoesVeiculo() {
      return [
        { text: this.$t('operation.lastPositionHeader.positionDt'), value: "dt_posicao_extenso" },
        { text: this.$t('operation.lastPositionHeader.inclusionDt'), value: "dt_inclusao_extenso" },
        { text: this.$t('operation.lastPositionHeader.lat'), value: "lat" },
        { text: this.$t('operation.lastPositionHeader.lng'), value: "lng" },
        { text: this.$t('operation.lastPositionHeader.valid'), value: "valida" },
        { text: this.$t('operation.lastPositionHeader.outOfOrder'), value: "fora_de_ordem" },
        { text: this.$t('operation.lastPositionHeader.delay'), value: "delay" }]
    },
    itensSelectTratada() {
      return [
        { id: "0", descricao: this.$t('button.dismiss') },
        { id: 1, descricao: this.$t('button.confirm') }]
    },
    headersGridStatus() {
      return [
        { text: this.$t('operation.headerGriStatus.company'), value: "razao_social" },
        { text: this.$t('operation.headerGriStatus.lineName'), value: "nome_linha" },
        { text: this.$t('operation.headerGriStatus.vehicleCode'), value: "cod_veiculo" },
        { text: this.$t('operation.headerGriStatus.lastGpsDate'), value: "dt_gps" },
        { text: this.$t('operation.headerGriStatus.lastGpsLat'), value: "lat" },
        { text: this.$t('operation.headerGriStatus.lastGpsLng'), value: "lng" },
        { text: this.$t('operation.headerGriStatus.lastValidatorDate'), value: "dt_validador" },
        { text: this.$t('operation.headerGriStatus.lastValidatorLat'), value: "lat_bilhetagem" },
        { text: this.$t('operation.headerGriStatus.lastValidatorLng'), value: "lng_bilhetagem" }]
    },
    headersStatusVeiculos() {
      return [
        { text: this.$t('operation.headerStatusVehicle.company'), value: "razao_social" },
        { text: this.$t('operation.headerStatusVehicle.lineName'), value: "nome_linha" },
        { text: this.$t('operation.headerStatusVehicle.vehicleCode'), value: "cod_veiculo" },
        { text: this.$t('operation.headerStatusVehicle.lastGpsDate'), value: "dt_gps" },
        { text: this.$t('operation.headerStatusVehicle.lastGpsLat'), value: "lat" },
        { text: this.$t('operation.headerStatusVehicle.lastGpsLng'), value: "lng" },
        { text: this.$t('operation.headerStatusVehicle.lastValidatorDate'), value: "dt_validador" },
        { text: this.$t('operation.headerStatusVehicle.lastValidatorLat'), value: "lat_bilhetagem" },
        { text: this.$t('operation.headerStatusVehicle.lastValidatorLng'), value: "lng_bilhetagem" },
        { text: this.$t('operation.notificationHeaders.action'), value: "actions", sortable: false }]
    },
    headersDiario() {
      return [
        { text: this.$t('tripOperation.entryId'), value: "id_entrada_diario", align: " d-none" },
        { text: this.$t('tripOperation.date'), value: "dt_entrada" },
        { text: this.$t('tripOperation.type'), value: "descricao_tipo_entrada" },
        { text: this.$t('tripOperation.reason'), value: "descricao_motivo" },
        { text: this.$t('tripOperation.observations'), value: "observacoes" }]
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('rules.messageDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    ...mapGetters('user', {
      nome_usuario: 'nome',
      razao_social: 'empresa',
      id_perfil_usuario: 'idPerfil',
      perfil_usuario: 'perfil',
      is_superadmin: 'super',
    }),
    ...mapGetters('config', {
      tempoAtualizacaoNotificacoes: 'tempoAtualizacaoNotificacoesAjustado',
      tempoAtualizacaoLinhas: 'tempoAtualizacaoLinhasAjustado',
      raioCercaPadrao: 'raioCercaPadrao'
    }),
    isUrbano() {
      return modo === 0;
    },
    hasGuias() {
      return this.config ? this.config.usar_guias == 1 : false;
    },
    ordemDeServico() {
      return this.isUrbano ? this.$tc('guide.self', 1) : this.$tc('schedule.schedule', 1);
    },
    showInfoValidador() {
      return this.setup.has_validador === 1;
    },
    statusOperacaoContext() {
      return {
        showInfoValidador: this.showInfoValidador,
        hasGuias: this.hasGuias,
      };
    },
    navegaPosicaoPosteriorDisabled() {
      return this.indexPosicaoClicked === this.posicoesCarro.length - 1;
    },
    navegaPosicaoAnteriorDisabled() {
      return this.indexPosicaoClicked === 0;
    },
    posicoesCarroFiltered() {
      return this.indexPosicaoClicked === null ? this.posicoesCarro : [this.posicoesCarro[this.indexPosicaoClicked]];
    },
    cercasComuns() {
      const poiLabel = this.$t('operation.poi');
      return this.cercas.filter((c) => c.codigo_cerca !== poiLabel);
    },
    cercasComunsGeoJson() {
      const poiLabel = this.$t('operation.poi');
      return this.cercasGeojson.filter((c) => c.codigo_cerca !== poiLabel);
    },
    cercasComunsCirculares() {
      const poiLabel = this.$t('operation.poi');
      return this.cercasCirculares.filter((c) => c.codigo_cerca !== poiLabel);
    },
    veiculosStandAlone() {
      const unidadesItems = this.unidadesPermitidas.map((u) => ({
        cod_unidade: u.cod_unidade,
        id_unidade: u.id_unidade,
        type: 'unity',
        display: u.cod_unidade
      }));

      const veiculosItems = this.veiculos.map((v) => ({
        cod_veiculo: v.cod_veiculo,
        type: 'vehicle',
        display: v.cod_veiculo
      }));

      // Adicionar separadores com valores únicos que não podem ser selecionados
      const separadorUnidades = {
        type: 'separator',
        display: this.$t('operation.unities'),
        isSeparator: true,
        disabled: true,
        value: '__SEPARATOR_UNIDADES__'
      };
      const separadorVeiculos = {
        type: 'separator',
        display: this.$t('operation.vehicles'),
        isSeparator: true,
        disabled: true,
        value: '__SEPARATOR_VEICULOS__'
      };

      return [separadorUnidades, ...unidadesItems, separadorVeiculos, ...veiculosItems];
    },
    filteredItemsStatusVeiculos() {
      return this.veiculosStatusVeiculos;
    },
    headersStatusVeiculosWithProperties() {
      return this.headersStatusVeiculos.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    headersUltimasPosicoesVeiculoWithProperties() {
      return this.headersUltimasPosicoesVeiculo.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    headersDiarioWithProperties() {
      return this.headersDiario.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    headersGridStatusWithProperties() {
      return this.headersGridStatus.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    totalcarrosonline() {
      return this.veiculos.filter(function (el) {
        return el.gps_offline === 0;
      }).length;
    },
    totalcarrosgpsoffline() {
      return this.veiculos.filter(function (el) {
        return el.gps_offline === 1;
      }).length;
    },
    totalcarrosvalidadoroffline() {
      return this.veiculos.filter(function (el) {
        return el.validador_offline === 1 && !(el.id_status_validador == 5 || el.id_status_validador == 6);
      }).length;
    },
    totalcarrossemguia() {
      return this.veiculosLinha.filter(function (el) {
        return el.id_guia === null &&
          el.gps_offline === 0 &&
          el.validador_offline === 0 &&
          el.cod_motorista_veiculo;
      }).length;
    },
    totalcarroslinhainconsistenteguia() {
      return this.veiculosLinha.filter(function (el) {
        return el.id_guia !== null &&
          el.id_linha_guia !== el.id_linha &&
          el.gps_offline === 0 &&
          el.validador_offline === 0 &&
          el.cod_motorista_veiculo;
      }).length;
    },
    totalcarrosmotoristainconsistenteguia() {
      return this.veiculosLinha.filter(function (el) {
        return el.id_guia !== null &&
          el.id_motorista_guia !== el.cod_motorista_veiculo &&
          el.gps_offline === 0 &&
          el.validador_Offline === 0 &&
          el.cod_motorista_veiculo;
      }).length;
    },
    totalcarroscobradorinconsistenteguia() {
      return this.veiculosLinha.filter(function (el) {
        return el.id_guia !== null &&
          el.id_cobrador_guia !== el.cod_cobrador_veiculo &&
          el.gps_offline === 0 &&
          el.validador_Offline === 0 &&
          el.cod_motorista_veiculo;
      }).length;
    },
    totalcarrosnarota() {
      return this.veiculosLinha.filter(function (el) {
        return el.sentido === 1 || el.sentido === 0;
      }).length;
    },
    dtiniciobaseRules() {
      if (this.dtiniciobase > new Date()) {
        return this.$t('rules.inicialBiggerThanFinalDate') + " !!";
      } else {
        return true;
      }
    },
    idsUnidadesPermitidas() {
      const ids = new Set();
      for (const l of this.linhas) {
        if (!l || !Array.isArray(l.unidades)) continue;
        // Linha sem unidade → grupo "Sem Unidade" (-1), se a API o devolver.
        if (l.unidades.length === 0) ids.add('-1');
        for (const idUnidade of l.unidades) {
          if (idUnidade !== null && idUnidade !== undefined) {
            ids.add(String(idUnidade));
          }
        }
      }
      return ids;
    },
    unidadesPermitidas() {
      const ids = this.idsUnidadesPermitidas;
      return this.unidades.filter((u) => ids.has(String(u.id_unidade)));
    },
    filteredUnidades() {
      if (this.search == "") {
        return this.unidadesPermitidas;
      } else {
        const searchLower = this.search.toLowerCase();
        const linhasPorUnidade = this.linhasPorUnidade;
        return this.unidadesPermitidas.filter((item) => {
          return (
            item.descricao_unidade.toLowerCase().match(searchLower) ||
            item.cod_unidade.toLowerCase().match(searchLower) ||
            (linhasPorUnidade.get(item.id_unidade) || []).length > 0
          );
        });
      }
    },
    linhasPorUnidade() {
      const map = new Map();
      for (const l of this.filteredLinhas) {
        if (!l.unidades || l.unidades.length === 0) {
          const arr = map.get(-1) || (map.set(-1, []), map.get(-1));
          arr.push(l);
        } else {
          for (const idUnidade of l.unidades) {
            const arr = map.get(idUnidade) || (map.set(idUnidade, []), map.get(idUnidade));
            arr.push(l);
          }
        }
      }
      return map;
    },
    linhasById() {
      const map = new Map();
      for (const l of this.linhas) {
        map.set(l.id_linha, l);
      }
      return map;
    },
    idsLinhasPermitidas() {
      return new Set(this.linhas.map((l) => String(l.id_linha)));
    },
    idsEmpresasPermitidas() {
      return new Set(
        (Array.isArray(this.empresasPermitidas) ? this.empresasPermitidas : []).map((id) =>
          String(id)
        )
      );
    },
    linhasSelecionadasIds() {
      return new Set(this.linhasSelecionadas.map((l) => l.id_linha));
    },
    veiculosStandAloneByDisplay() {
      const map = new Map();
      for (const item of this.veiculosStandAlone) {
        if (!item.isSeparator) {
          map.set(item.display, item);
        }
      }
      return map;
    },
    contagemPorStatus() {
      const counts = new Map();
      const context = this.statusOperacaoContext;
      const statusConfig = this.statusVeiculosOperacao;
      for (const v of this.veiculosLinha) {
        const resolved = resolveVeiculoStatus(v, statusConfig, context);
        if (resolved) {
          counts.set(resolved.cod_status, (counts.get(resolved.cod_status) || 0) + 1);
        }
      }
      return counts;
    },
    filteredLinhas() {
      if (this.search == "") {
        return this.linhas;
      } else {
        return this.linhas.filter((item) => {
          return (
            item.descricao_unidade.toLowerCase().match(this.search.toLowerCase()) ||
            item.cod_unidade.toLowerCase().match(this.search.toLowerCase()) ||
            item.razao_social.toLowerCase().match(this.search.toLowerCase()) ||
            item.nome_linha.toLowerCase().match(this.search.toLowerCase()) ||
            item.cod_linha.toLowerCase().match(this.search.toLowerCase())
          );
        });
      }
    },
    filteredItemsMap() {
      if (this.search == "") {
        return this.linhas;
      } else {
        return this.linhas.filter((item) => {
          return (
            item.razao_social.toLowerCase().match(this.search.toLowerCase()) ||
            item.cod_area.toLowerCase().match(this.search.toLowerCase()) ||
            item.nome_linha.toLowerCase().match(this.search.toLowerCase())
          );
        });
      }
    },
    filteredVeiculos() {
      if (this.searchCarros == "") {
        return this.filteredVeiculosLinha;
      } else {
        return this.filteredVeiculosLinha.filter((item) => {
          return item.cod_veiculo
            .toLowerCase()
            .match(this.searchCarros.toLowerCase());
        });
      }
    },
    filteredLinhasSelecionadas() {
      if (this.searchLinhasSelecionadas == "") {
        return this.linhasSelecionadas;
      } else {
        return this.linhasSelecionadas.filter((item) => {
          return item.cod_linha
            .toLowerCase()
            .match(this.searchLinhasSelecionadas.toLowerCase());
        });
      }
    },
    filteredPontosInteresse() {
      if (this.searchPontosInteresse == "") {
        return this.pontosInteresse;
      } else {
        return this.pontosInteresse.filter((item) => {
          return item.nome_cerca
            .toLowerCase()
            .match(this.searchPontosInteresse.toLowerCase());
        });
      }
    },
    rotasVisiveis() {
      const visible = new Set();
      const showIdaOnly = this.showIda && !this.showVolta;
      const showVoltaOnly = this.showVolta && !this.showIda;

      for (const r of this.rotas) {
        if (!r.geojson) continue;

        let isVisible = true;
        if (showIdaOnly) {
          isVisible = r.id_sentido == 1;
        } else if (showVoltaOnly) {
          isVisible = r.id_sentido == 2;
        }

        if (r.cod_tipo_rota === 'DES') {
          isVisible = this.showDeslocamento;
        }

        if (isVisible) {
          visible.add(r.id_rota);
        }
      }

      return visible;
    },
    sinoticoTitle() {
      return this.linhaSelecionada ? `${this.$t('operation.synopticLineBoard')} ${this.linhaSelecionada.nome_linha}` : "";
    },
    cercasGeojson() {
      return this.cercas.filter((c) => c.geojson);
    },
    cercasCirculares() {
      return this.cercas.filter((c) => !c.geojson);
    },

    labelProcurar() {
      return this.$t('system.search')
    },
    statusFiltrosDisponiveis() {
      return (this.statusVeiculosOperacao || [])
        .filter((s) => Number(s.ativo) !== 0)
        .slice()
        .sort((a, b) => Number(a.prioridade) - Number(b.prioridade));
    },
  },
  methods: {
    /** Áreas de Planejamento no mapa (carregadas no primeiro uso; Zona de Risco com marcação própria). */
    async mostrarAreasMapa() {
      if (!this.areasMapaCarregadas) {
        this.loadingAreasMapa = true;
        try {
          const res = await apiController.request(apiController.endpoints.getallAreasmapa, { silent: true });
          this.areasMapa = Array.isArray(res.data) ? res.data : [];
          this.areasMapaCarregadas = true;
        } catch (e) {
          // Sem permissão para a camada: some com o controle em vez de insistir.
          if (e && e.response && (e.response.status === 401 || e.response.status === 403)) this.areasMapaDisponivel = false;
          this.showPolygonMapaOperacao = false;
          return;
        } finally {
          this.loadingAreasMapa = false;
        }
      }
      if (!this.showPolygonMapaOperacao) return;
      this.removerCamadaAreas();
      const map = this.$refs.map && this.$refs.map.mapObject;
      if (!map) return;
      const grupo = L.layerGroup();
      this.areasMapa.forEach((area) => {
        const camada = camadaDaArea(area, { rotuloZona: this.$t("area.riskZone") });
        if (camada) grupo.addLayer(camada);
      });
      grupo.addTo(map);
      this._camadaAreas = grupo;
    },
    removerCamadaAreas() {
      if (this._camadaAreas) {
        this._camadaAreas.remove();
        this._camadaAreas = null;
      }
    },
    ...mapMutations('timeout', [
      'resetNotif',
      'resetLinhas',
      'resetVeiculos',
      'resetTempo'
    ]),
    isPollingActive() {
      return this.pollingActive && !this._isDestroyed;
    },
    createPollingCancelToken() {
      if (!this.pollingCancelSource) {
        this.pollingCancelSource = axios.CancelToken.source();
      }
      return this.pollingCancelSource.token;
    },
    cancelPollingRequests() {
      if (this.pollingCancelSource) {
        this.pollingCancelSource.cancel('component destroyed');
        this.pollingCancelSource = null;
      }
    },
    schedulePolling(resetMutation, callback, delay) {
      if (!this.isPollingActive()) return;
      this[resetMutation](setTimeout(() => {
        if (!this.isPollingActive()) return;
        callback();
      }, delay));
    },
    getConfig() {
      return apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.config = response.data[0];
          if (this.config && this.config.limite_alertas_tela != null) {
            this.limiteAlertasTela = this.config.limite_alertas_tela;
          }
          this.center = this.center || [this.config.lat_default, this.config.lng_default];
        },
        onError: (e) => {
          if (axios.isCancel(e) || !this.isPollingActive()) return;
          EventBus.$emit('show-error', { error: e });
          this.config = { periodo_busca_alertas_minutos: 1440 };
        },
      })
        .then((response) => response.data[0])
        .catch(() => ({ periodo_busca_alertas_minutos: 1440 }));
    },
    async initialize() {
      if (!this.pageLoaded) {
        this.loadingPage = true;
        this.pageLoaded = false;
      }

      this.populaRecursos();
      if (this.linhasSelecionadas.length > 0) {
        this.showLineMap();
      } else {
        if (this.veiculosStandAloneSelected.length > 0) {
          this.veiculoStandAloneChanged();
        }
      }

      this.filterChanged();
      if (!(this.showIda && this.showVolta)) {
        this.sentidoFiltered();
      }

      if (this.setup.has_condicao_climatica === 1) {
        await this.populaCidades();
        this.populaTempo();
      }
    },
    async populaCidades() {
      await apiController.request(apiController.endpoints.getallCidades, {
        silent: true,
        onSuccess: (response) => {
          this.cidades = response.data;
        },
        onError: (e) => {
          console.log("Response : " + e.message);
        },
      }).catch(() => {});
    },
    async populaSetup() {
      await apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = Object.assign({}, response.data[0]);
        },
        onError: (e) => {
          console.log("Response : " + e.message);
        },
      });
    },
    populaTempo() {
      if (!this.isPollingActive()) return;
      apiController.request(apiController.endpoints.getCondicaoatual, {
        silent: true,
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.weatherConditions = Array.isArray(response.data) ? response.data : [];
          if (this.weatherConditions.length === 0) {
            return;
          }
          if (!this.weatherCitySelected) {
            this.weatherCitySelected = this.weatherConditions[0];
          }
          this.weatherCityChanged(this.weatherCitySelected);
          this.schedulePolling('resetTempo', () => this.populaTempo(), 3600000);
        },
        onError: (e) => {
          if (axios.isCancel(e)) return;
          console.log("Response : " + e.message);
        },
      }).catch(() => {});
    },
    populaLimiteAlertasTela() {
      if (this.config && this.config.limite_alertas_tela != null) {
        this.limiteAlertasTela = this.config.limite_alertas_tela;
        return;
      }
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.limiteAlertasTela = response.data[0].limite_alertas_tela;
          if (!this.config) {
            this.config = response.data[0];
          }
        },
        onError: (e) => {
          console.log("Response : " + e.message);
        },
      });
    },
    tratarNotificacao(notificacao) {
      this.showResetNotificacaoDialog(notificacao);
    },
    weatherCityChanged(item) {
      if (!item) {
        return;
      }
      this.weatherCitySelected = this.weatherConditions.find((w) => w.id_cidade == item.id_cidade);
      if (this.weatherCitySelected) {
        this.weatherColor = this.weatherCitySelected.has_precipitation == 1 ? "blue" : "orange";
        this.weatherIcon = this.weatherCitySelected.has_precipitation == 1 ? "mdi-weather-rainy" : "mdi-weather-sunny";
        this.weatherTemperature = this.weatherCitySelected.temp_media;
        this.weatherCityName = this.weatherCitySelected.cidade;
      } else {
        this.weatherColor = null;
        this.weatherIcon = null;
        this.weatherTemperature = null;
        this.weatherCityName = this.cidades[0] ? this.cidades[0].nome : null;
      }
    },
    async exportPDF(div) {
      this.mensagemProgressoDialog = this.$t('operation.exportingPdfWait');
      this.progressoDialog = true;
      await domtoimage
        .toPng(div)
        .then(function (dataUrl) {
          var img = new Image(800, 400);
          img.src = dataUrl;
          const doc = new jsPDF({
            orientation: "l",
            //unit: "cm",
            //format: [300, 700],
            format: "a4",
          });
          doc.addImage(img, "JPEG", 5, 5, 285, 195);
          const date = new Date();
          const filename =
            "notificacao_" +
            date.getFullYear() +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            ("0" + date.getDate()).slice(-2) +
            ("0" + date.getHours()).slice(-2) +
            ("0" + date.getMinutes()).slice(-2) +
            ("0" + date.getSeconds()).slice(-2) +
            ".pdf";
          doc.save(filename);
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
      this.mensagemProgressoDialog = "";
      this.progressoDialog = false;
    },
    closeStatusVeiculos() {
      this.dialogStatusVeiculos = false;
    },
    showDialogStatusVeiculos(tipo, titulo, hasline, id, descricao) {
      if (hasline) {
        this.tituloStatusVeiculos = titulo + " - " + descricao;
        //Total com linha
        if (tipo == 0) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            if (i.ativo == 1) {
              return i.id_linha_guia == id || i.id_linha == id;
            }
          });
        }
        // GPS online com linha
        if (tipo == 1) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.gps_offline == 0 && (i.id_linha_guia !== null ? i.id_linha_guia == id : i.id_linha == id);
          });
        }
        // GPS offline com linha
        if (tipo == 2) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.gps_offline == 1 && (i.id_linha_guia !== null ? i.id_linha_guia == id : i.id_linha == id);
          });
        }
        // Validador offline com linha
        if (tipo == 3) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.validador_offline == 1 && i.id_linha_guia !== null && i.id_linha_guia == id;
          });
        }

        if (tipo == 4) {
          let getUnidade = this.getIdUnidadeVeiculo;
          let linhas = this.linhasById;
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return getUnidade(i, linhas) == id && (i.id_linha_guia || i.id_linha);
          });
        }

        if (tipo == 5) {
          let getUnidade = this.getIdUnidadeVeiculo;
          let linhas = this.linhasById;
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return (
              i.gps_offline == 0 &&
              getUnidade(i, linhas) == id &&
              (i.id_linha || i.id_linha_guia)
            );
          });
        }

        if (tipo == 6) {
          let getUnidade = this.getIdUnidadeVeiculo;
          let linhas = this.linhasById;
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return (
              i.gps_offline == 1 &&
              getUnidade(i, linhas) == id &&
              (i.id_linha || i.id_linha_guia)
            );
          });
        }

        if (tipo == 7) {
          let getUnidade = this.getIdUnidadeVeiculo;
          let linhas = this.linhasById;
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.validador_offline == 1 && getUnidade(i, linhas) == id && i.id_linha_guia;
          });
        }
      } else {
        this.tituloStatusVeiculos = titulo;
        // Total sem linha
        if (tipo == 0) {
          this.veiculosStatusVeiculos = this.veiculos;
        }
        // GPS e validador online sem linha
        if (tipo == 1) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.gps_offline == 0;
          });
        }
        // GPS offline sem linha
        if (tipo == 2) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.gps_offline == 1;
          });
        }
        // Validador offline sem linha
        if (tipo == 3) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.validador_offline == 1;
          });
        }
        // Sem guia
        if (tipo == 4) {
          this.veiculosStatusVeiculos = this.veiculos.filter((i) => {
            return i.id_guia === null;
          });
        }
      }

      this.dialogStatusVeiculos = true;
    },
    veiculoStandAloneChanged() {
      this.cercas = [];
      this.pontosInteresse = [];
      this.linhaClicked = null;
      this.nomeLinhaClicked = "";
      this.shapeClicked = null;
      this.shapeAreaClicked = null;
      this.markerVeiculosVisible = false;
      this.nomerota = "";
      this.showRota = false;
      this.showRotaVisible = false;
      this.showCercaMapaOperacao = false;
      this.markerPontosInteresseVisible = true;



      this.filtroVeiculosStandAlone();
      const filteredStandAlone = this.getCurrentFilteredVeiculosLinha();
      if (filteredStandAlone.length > 0) {
        this.markerVeiculosVisible = true;
        this.center = [filteredStandAlone[0].lat, filteredStandAlone[0].lng];
      }
    },
    async printScreen() {
      let el = this.$refs.printMe;
      var a = document.createElement("a");
      a.href = (await html2canvas(el))
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      a.download = "screenshot-plotagens.jpg";
      a.click();
    },
    getDataConsulta(dt) {
      var retorno = null;
      if (typeof dt == "string") {
        retorno =
          dt.substring(6, 10) +
          dt.substring(3, 5) +
          dt.substring(0, 2) +
          dt.substring(11, 13) +
          dt.substring(14, 16) +
          dt.substring(17);
      } else {
        var temp = dt.toLocaleString();
        retorno =
          temp.substring(6, 10) +
          temp.substring(3, 5) +
          temp.substring(0, 2) +
          temp.substring(12, 14) +
          temp.substring(15, 17) +
          temp.substring(18);
      }
      return retorno;
    },
    populaPontosInteresse() {
      this.pontosInteresse = this.cercas.filter((c) => c.codigo_cerca === 'POI');
      this.pontosInteresseGeoJson = this.pontosInteresse.filter((p) => p.geojson && p.geojson?.geometry.coordinates.length > 1);
      this.pontosInteresseCirculares = this.pontosInteresse.filter((p) => !p.geojson || p.geojson?.geometry.coordinates.length === 1);
    },
    populaRecursos() {
      if (this.is_superadmin) {
        apiController.request(apiController.endpoints.getallRecursos, {
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaLinhasOperacao();
            this.populaVeiculos();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.id_usuario },
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaLinhasOperacao();
            this.populaVeiculos();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    limparFiltrosGridStatus() {
      var d = new Date();
      this.dtiniciobase = d.toLocaleString().substring(0, 10) + " 23:59:59";
      this.idEmpresaSelected = null;
      this.idLinhaSelected = null;
      this.idVeiculoSelected = null;
      this.itensGridStatus = [];
      this.populaEmpresasSelect();
      this.populaLinhasSelect();
      this.populaVeiculosSelect();
    },
    showGridStatus() {
      this.populaEmpresasSelect();
      this.populaLinhasSelect();
      this.populaVeiculosSelect();
      var d = new Date();
      this.dtiniciobase = d.toLocaleString().substring(0, 10) + " 23:59:59";
      this.dialogGridStatus = true;
    },
    closeGridStatus() {
      this.$router.replace({ path: '/operacao' });
      this.idEmpresaSelected = null;
      this.idLinhaSelected = null;
      this.idVeiculoSelected = null;
      this.itensGridStatus = [];
      this.dialogGridStatus = false;
    },
    filtraGridStatusPorVeiculo(dt) {
      var id = this.idVeiculoSelected;
      this.itensGridStatus = this.veiculos.filter(function (el) {
        return (
          el.id_veiculo == id &&
          Date.parse(
            el.dt_gps.substring(6, 10) +
            "-" +
            el.dt_gps.substring(3, 5) +
            "-" +
            el.dt_gps.substring(0, 2) +
            "T" +
            el.dt_gps.substring(11)
          ) <= dt &&
          el.gps_offline == 1 &&
          el.ativo == 1
        );
      });
    },
    filtraGridStatusPorLinha(dt) {
      var id = this.idLinhaSelected;
      this.itensGridStatus = this.veiculos.filter(function (el) {
        return (
          el.id_linha == id &&
          Date.parse(
            el.dt_gps.substring(6, 10) +
            "-" +
            el.dt_gps.substring(3, 5) +
            "-" +
            el.dt_gps.substring(0, 2) +
            "T" +
            el.dt_gps.substring(11)
          ) <= dt &&
          el.gps_offline == 1 &&
          el.ativo == 1
        );
      });
    },
    filtraGridStatusPorEmpresa(dt) {
      var id = this.idEmpresaSelected;
      this.itensGridStatus = this.veiculos.filter(function (el) {
        return (
          el.id_empresa == id &&
          Date.parse(
            el.dt_gps.substring(6, 10) +
            "-" +
            el.dt_gps.substring(3, 5) +
            "-" +
            el.dt_gps.substring(0, 2) +
            "T" +
            el.dt_gps.substring(11)
          ) <= dt &&
          el.gps_offline == 1 &&
          el.ativo == 1
        );
      });
    },
    filtraGridStatusTodos(dt) {
      this.itensGridStatus = this.veiculos.filter(function (el) {
        return (
          Date.parse(
            el.dt_gps.substring(6, 10) +
            "-" +
            el.dt_gps.substring(3, 5) +
            "-" +
            el.dt_gps.substring(0, 2) +
            "T" +
            el.dt_gps.substring(11)
          ) <= dt &&
          el.gps_offline == 1 &&
          el.ativo == 1
        );
      });
    },
    filtroGridStatus() {
      this.loadinggridstatus = true;
      var dtstr = "";
      var dt = null;
      if (typeof this.dtiniciobase == "string") {
        dtstr = this.dtiniciobase;
        dt = Date.parse(
          dtstr.substring(6, 10) +
          "-" +
          dtstr.substring(3, 5) +
          "-" +
          dtstr.substring(0, 2) +
          "T" +
          dtstr.substring(11)
        );
      } else {
        dtstr = this.dtiniciobase.toLocaleString();
        dt = Date.parse(
          dtstr.substring(6, 10) +
          "-" +
          dtstr.substring(3, 5) +
          "-" +
          dtstr.substring(0, 2) +
          "T" +
          dtstr.substring(12)
        );
      }
      if (this.idVeiculoSelected) {
        this.filtraGridStatusPorVeiculo(dt);
      } else {
        if (this.idLinhaSelected) {
          this.filtraGridStatusPorLinha(dt);
        } else {
          if (this.idEmpresaSelected) {
            this.filtraGridStatusPorEmpresa(dt);
          } else {
            this.filtraGridStatusTodos(dt);
          }
        }
      }
      this.loadinggridstatus = false;
    },
    empresasSelectChanged() {
      var id = this.idEmpresaSelected;
      this.linhasSelect = this.linhas.filter(function (el) {
        return el.id_empresa === id;
      });
    },
    linhasSelectChanged() {
      var id = this.idLinhaSelected;
      this.veiculosSelect = this.veiculos.filter(function (el) {
        return el.id_linha === id;
      });
    },
    populaEmpresasSelect() {
      this.empresasSelect = this.veiculos
        .map((e) => {
          return { id_empresa: e.id_empresa, razao_social: e.razao_social };
        })
        .filter((element, index, array) => {
          return (
            array.findIndex((a) => a.id_empresa == element.id_empresa) === index
          );
        });
    },
    populaLinhasSelect() {
      this.linhasSelect = this.linhas;
    },
    populaVeiculosSelect() {
      this.veiculosSelect = this.veiculos;
    },
    showDrawer() {
      if (this.showingDrawer) {
        this.showingDrawer = false;
      } else {
        this.openDrawerVeiculos();
      }
    },
    async openDrawerVeiculos() {
      this.drawerVeiculosMounted = true;
      await this.$nextTick();
      this.showingDrawer = true;
    },
    showDrawerLinhas() {
      this.showingDrawerLinhas
        ? (this.showingDrawerLinhas = false)
        : (this.showingDrawerLinhas = true);
    },
    showDrawerLinhasSelecionadas() {
      if (this.showingDrawerLinhasSelecionadas) {
        this.showingDrawerLinhasSelecionadas = false;
      } else {
        this.openDrawerLinhasSelecionadas();
      }
    },
    async openDrawerLinhasSelecionadas() {
      this.drawerLinhasSelecionadasMounted = true;
      await this.$nextTick();
      this.showingDrawerLinhasSelecionadas = true;
    },
    showDrawerPontosInteresse() {
      if (this.showingDrawerPontosInteresse) {
        this.showingDrawerPontosInteresse = false;
      } else {
        this.openDrawerPontosInteresse();
      }
    },
    async openDrawerPontosInteresse() {
      this.drawerPontosInteresseMounted = true;
      await this.$nextTick();
      this.showingDrawerPontosInteresse = true;
    },
    async openQuadroViagens() {
      this.quadroViagensMounted = true;
      await this.$nextTick();
      this.showGridViagens = true;
    },
    setFilteredVeiculosLinha(value) {
      if (this._batchingFilteredVeiculos) {
        this._pendingFilteredVeiculosLinha = value;
      } else {
        this.filteredVeiculosLinha = value;
      }
    },
    getCurrentFilteredVeiculosLinha() {
      if (this._batchingFilteredVeiculos && this._pendingFilteredVeiculosLinha !== null) {
        return this._pendingFilteredVeiculosLinha;
      }
      return this.filteredVeiculosLinha;
    },
    filtroVeiculosLinha() {
      let linesToFilter = this.linhasSelecionadas.map((l) => l.id_linha);
      this.veiculosLinha = this.veiculos.filter(function (el) {
        if (el.ativo == 1) {
          return linesToFilter.includes(el.id_linha_guia) || linesToFilter.includes(el.id_linha);
        }
      });
      this.setFilteredVeiculosLinha(this.veiculosLinha);
    },
    filtroVeiculosStandAlone() {
      this.veiculosLinha = [];

      // Separar unidades e veículos selecionados
      const unidadesSelecionadas = [];
      const veiculosSelecionados = [];
      const byDisplay = this.veiculosStandAloneByDisplay;
      const linhasById = this.linhasById;

      this.veiculosStandAloneSelected.forEach((selected) => {
        const item = byDisplay.get(selected);
        if (item) {
          if (item.type === 'unity') {
            unidadesSelecionadas.push(item.id_unidade);
          } else if (item.type === 'vehicle') {
            veiculosSelecionados.push(item.cod_veiculo);
          }
        }
      });

      // Filtrar veículos por unidades selecionadas
      if (unidadesSelecionadas.length > 0) {   
        unidadesSelecionadas.forEach((idUnidade) => {
          const veiculosUnidade = this.veiculos.filter((v) => {
            if (v.ativo !== 1) return false;
            const idLinhaVeiculo = v.id_linha_guia || v.id_linha;
            if (!idLinhaVeiculo) return false;
            const linha = linhasById.get(idLinhaVeiculo);
            if (!linha) return false;
            if (idUnidade === -1) return !linha.unidades || linha.unidades.length === 0;
            return linha.unidades && linha.unidades.includes(idUnidade);
          });
          this.veiculosLinha.push(...veiculosUnidade);
        });
      }

      // Filtrar veículos selecionados diretamente
      if (veiculosSelecionados.length > 0) {
        const veiculosDiretos = this.veiculos.filter((item) =>
          veiculosSelecionados.includes(item.cod_veiculo)
        );
        this.veiculosLinha.push(...veiculosDiretos);
      }

      // Remover duplicatas
      const veiculosIds = new Set();
      this.veiculosLinha = this.veiculosLinha.filter((v) => {
        if (veiculosIds.has(v.id_veiculo)) {
          return false;
        }
        veiculosIds.add(v.id_veiculo);
        return true;
      });

      const vehiclesWithoutLineLabel = this.$t('operation.vehiclesWithoutLine');
      if (this.veiculosStandAloneSelected.includes(vehiclesWithoutLineLabel)) {
        this.veiculosLinha.push(...this.veiculos.filter((v) => {
          if (!veiculosIds.has(v.id_veiculo) && v.id_linha === null && v.id_linha_guia === null) {
            veiculosIds.add(v.id_veiculo);
            return v;
          }
        }));
      }

      this.setFilteredVeiculosLinha(this.veiculosLinha);
    },
    beep() {
      if (!this._beepAudio) {
        this._beepAudio = new Audio("beep.mp3");
      }
      this._beepAudio.play();
    },
    populaCercasPorLinha(idlinhas) {
      apiController.request(apiController.endpoints.getCercasporlinha, {
        data: idlinhas,
        onSuccess: (response) => {
          // Check if response is valid
          if (response.data && response.data.erro) {
            console.error('Erro ao buscar cercas:', response.data.mensagem);
            return;
          }

          // Ensure response.data is an array
          if (!Array.isArray(response.data)) {
            console.error('Resposta inválida da API - esperado array:', response.data);
            return;
          }

          // Check for alternative cercas
          const alternativeCercas = response.data.filter((c) => c.is_vigencia === 1);
          if (alternativeCercas.length > 0) {
            console.log(`✓ ${alternativeCercas.length} cerca(s) alternativa(s) ativa(s) hoje:`,
              alternativeCercas.map(c => c.nome_cerca));
          }

          for (var i = 0; i < response.data.length; i++) {
            let cerca = response.data[i]
            const colorIndex = i < LineColors.length ? i : i % LineColors.length;
            if (cerca.geojson) {
              if (typeof cerca.geojson === "string") {
                cerca.geojson = Object.freeze(JSON.parse(cerca.geojson));
              } else if (cerca.geojson && typeof cerca.geojson === "object") {
                cerca.geojson = Object.freeze(cerca.geojson);
              }

              cerca.style = {
                color: LineColors[colorIndex],
                fillColor: LineColors[colorIndex]
              };

              cerca.options = {
                onEachFeature: (feat, layer) => {
                  layer.bindPopup(feat.properties.name);
                }
              }
            } else {
              cerca.color = LineColors[colorIndex];
              cerca.latlngs = this.parseShapeNotificacao(cerca.shape);
            }
            this.cercas.push(cerca);
          }
          this.populaPontosInteresse();
        },
        onError: (e) => {
          this.mensagemProgressoDialog = "";
          this.progressoDialog = false;
          console.log("Response : " + e.message);
        },
      });
    },
    buildRotasMap(linha) {
      this.parseShape(linha, 1);
      if (this.currentLineColor === LineColors.length) {
        this.currentLineColor = 0;
      }
      this.currentLineColor += 1;
    },
    ensureLinhaRotasGeojson(linha) {
      const rotas = Array.isArray(linha && linha.rotas) ? linha.rotas : [];
      const precisaGeometria = rotas.length === 0 || rotas.some((r) => !r || !r.geojson);
      if (!precisaGeometria) {
        return Promise.resolve(linha);
      }
      return new Promise((resolve, reject) => {
        apiController.request(apiController.endpoints.getRotasporlinha, {
          data: [linha.id_linha],
          onSuccess: (response) => {
            const loaded = Array.isArray(response && response.data) ? response.data : [];
            linha.rotas = loaded;
            const idx = this.linhas.findIndex((l) => l && l.id_linha === linha.id_linha);
            if (idx !== -1) {
              this.$set(this.linhas[idx], 'rotas', loaded);
            }
            resolve(linha);
          },
          onError: (e) => reject(e),
        });
      });
    },
    centerMapOnLinhaRotas(linha) {
      const rota = Array.isArray(linha && linha.rotas) ? linha.rotas.find((r) => r && r.geojson) : null;
      if (!rota || !rota.geojson) return;
      let geojson = rota.geojson;
      if (typeof geojson === 'string') {
        try {
          geojson = JSON.parse(geojson);
        } catch (e) {
          return;
        }
      }
      if (geojson && geojson.geometry && Array.isArray(geojson.geometry.coordinates) && geojson.geometry.coordinates[0]) {
        this.center = [geojson.geometry.coordinates[0][1], geojson.geometry.coordinates[0][0]];
        return;
      }
      if (geojson && Array.isArray(geojson.features) && geojson.features[0] && geojson.features[0].geometry) {
        const coords = geojson.features[0].geometry.coordinates;
        if (Array.isArray(coords) && coords[0]) {
          this.center = [coords[0][1], coords[0][0]];
        }
      }
    },
    showLineMap() {
      this.veiculosStandAloneSelected = [];

      this.filtroVeiculosLinha();
      this.filterChanged();

      if (this.getCurrentFilteredVeiculosLinha().length > 0) {
        this.markerVeiculosVisible = true;
      } else {
        this.markerVeiculosVisible = false;
        this.showRota = true;
      }
    },
    async listItemClicked(linha) {
      let linhaIndex = this.linhasSelecionadas.findIndex((l) => l.id_linha === linha.id_linha);
      if (linhaIndex !== -1) {
        this.removeShape(linha.id_linha);
        this.linhasSelecionadas.splice(linhaIndex, 1);
      } else {
        try {
          await this.ensureLinhaRotasGeojson(linha);
        } catch (e) {
          console.log("Response : " + (e && e.message ? e.message : e));
          return;
        }
        linha.color = LineColors[this.currentLineColor];
        this.linhasSelecionadas.push(linha);
        this.buildRotasMap(linha);
        this.populaCercasPorLinha([linha.id_linha], false);
      }

      this.filtroVeiculosLinha();
      this.showLineMap();
      this.centerMapOnLinhaRotas(linha);

      this.showRotaVisible = true;
    },
    populaLinhasOperacao() {
      if (!this.isPollingActive()) return;
      apiController.request(apiController.endpoints.getLinhasoperacao, {
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          if (!response || !response.data) {
            this.linhas = [];
            this.loadingPage = false;
            this.pageLoaded = true;
            return;
          }

          if (response.data.erro) {
            EventBus.$emit('show-error', { error: { message: response.data.mensagem } });
            this.linhas = [];
            this.loadingPage = false;
            this.pageLoaded = true;
            return;
          }

          if (!Array.isArray(response.data)) {
            this.linhas = [];
            this.loadingPage = false;
            this.pageLoaded = true;
            return;
          }

          const empresasPermitidasArray = Array.isArray(this.empresasPermitidas) ? this.empresasPermitidas : [];

          this.linhas = response.data.filter((l) => {
            if (!l || typeof l !== 'object') return false;
            return empresasPermitidasArray.includes(l.id_empresa);
          });

          this.populaUnidades();
          this.loadingPage = false;
          this.pageLoaded = true;

          this.schedulePolling('resetLinhas', () => this.populaLinhasOperacao(), this.tempoAtualizacaoLinhas);
        },
        onError: (e) => {
          if (axios.isCancel(e) || !this.isPollingActive()) return;
          this.loadingPage = false;
          this.pageLoaded = true;
          this.linhas = [];
          console.log("Response : " + e.message);
        },
      });
    },
    populaCountNotificacoes() {
      if (!this.isPollingActive()) return;
      let today = DateUtils.getDateSQLFormatted(new Date());
      let dti = today.substring(0, 10) + "T00:00:00";
      let dtf = today.substring(0, 10) + "T23:59:59";

      apiController.request(apiController.endpoints.getTotalnotificacoesnotreseted, {
        params: { dti, dtf },
        data: this.linhas.map((l) => l.id_linha),
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.totalnotificacoes = response.data;
          if (this.totalnotificacoes.length === 0) {
            this.totalnotificacoes = [{ total: 0 }];
          }

          if (this.totalnotificacoesanterior != null) {
            if (
              this.totalnotificacoes[0].total > this.totalnotificacoesanterior
            ) {
              this.beep();
            }
          }
          this.populaNotificacoesImportantes();
          this.totalnotificacoesanterior = this.totalnotificacoes[0].total;

          this.schedulePolling('resetNotif', () => this.populaCountNotificacoes(), this.tempoAtualizacaoNotificacoes);
        },
        onError: (e) => {
          if (axios.isCancel(e)) return;
          console.log("Response : " + e.message);
        },
      });
    },
    populaNotificacoesImportantes() {
      if (!this.isPollingActive()) return;
      // Se a config não estiver carregada, recarrega antes de usar
      if (!this.config || !this.config.periodo_busca_alertas_minutos) {
        // Se não tem config, tenta recarregar uma vez
        if (!this.configLoading) {
          this.configLoading = true;
          this.getConfig().then(() => {
            this.configLoading = false;
            if (!this.isPollingActive()) return;
            // Após carregar, chama novamente a função
            this.populaNotificacoesImportantes();
          });
          return;
        }
      }

      let periodoMinutos = (this.config && this.config.periodo_busca_alertas_minutos)
        ? this.config.periodo_busca_alertas_minutos
        : 1440;


      let dtinicio = new Date();
      dtinicio.setMinutes(dtinicio.getMinutes() - periodoMinutos);

      let dti = DateUtils.getDateSQLFormatted(dtinicio);
      let dtf = DateUtils.getDateSQLFormatted(new Date());

      apiController.request(apiController.endpoints.getNotificacoespordata, {
        data: { dtinicio: dti, dtfim: dtf },
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          if (!Array.isArray(response.data)) {
            this.notificacoes = [];
            this.notificacoesImportantes = [];
            this.notificacoesImportantesVisiveis = [];
            return;
          }
          this.notificacoes = response.data.map((n) => ({
            ...n,
            descricao_tipo_notificacao: translateDbField(
              n.translation_key, 
              n.descricao_tipo_notificacao
            )
          }));
          if (!this.is_superadmin) {
            this.notificacoes = this.notificacoes.filter((n) =>
              notificacaoPertenceAoUsuario({
                notif: n,
                isSuperadmin: false,
                idsLinhas: this.idsLinhasPermitidas,
                idsEmpresas: this.idsEmpresasPermitidas,
              })
            );
          }
          const notifs = this.notificacoes
            .filter((n) => Number(n.show_alerta) === 1 && Number(n.reset) === 0)
            .map((n) => ({
              notificacao: n,
              message: this.buildMensagemNotificacao(n),
              color: n.cor,
            }));

          this.notificacoesImportantes = [];
          this.notificacoesImportantesVisiveis = [];

          if (notifs.length > 0) {
            notifs.forEach((n) => {
              this.notificacoesImportantes.push(n);
              if (this.notificacoesImportantesVisiveis.length < this.limiteAlertasTela) {
                this.notificacoesImportantesVisiveis.push(n);
              }
            });

            // sessionStorage.setItem("notificacoesImportantes", JSON.stringify(this.notificacoesImportantes));
            // sessionStorage.setItem("notificacoesImportantesVisiveis", JSON.stringify(this.notificacoesImportantesVisiveis));
          }
        },
        onError: (e) => {
          if (axios.isCancel(e)) return;
          console.log("Response : " + e.message);
        },
      });
    },
    populaVeiculos() {
      if (!this.isPollingActive()) return;
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.veiculos = response.data;
          if (this.$route.query.relatorio === 'gridstatus' && !this.dialogGridStatus) {
            this.showGridStatus();
          }
          if (this.dialogSinotico) {
            this.atualizarSinotico(this.linhaSelecionada);
          }

          this._batchingFilteredVeiculos = true;
          this._pendingFilteredVeiculosLinha = null;
          try {
            if (this.linhasSelecionadas.length > 0) {
              this.showLineMap();
            } else {
              if (this.veiculosStandAloneSelected.length > 0) {
                this.veiculoStandAloneChanged();
              }
            }

            this.filterChanged();
            if (!(this.showIda && this.showVolta)) {
              this.sentidoFiltered();
            }
          } finally {
            this._batchingFilteredVeiculos = false;
            if (this._pendingFilteredVeiculosLinha !== null) {
              this.filteredVeiculosLinha = this._pendingFilteredVeiculosLinha;
            }
            this._pendingFilteredVeiculosLinha = null;
          }
          this.schedulePolling('resetVeiculos', () => this.populaVeiculos(), 30000);
        },
        onError: (e) => {
          if (axios.isCancel(e)) return;
          console.log("Response : " + e.message);
        },
      });
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaUnidades() {
      if (this._unidadesLoaded) return;
      apiController.request(apiController.endpoints.getallUnidadesoperacao, {
        onSuccess: (response) => {
          if (response.data && Array.isArray(response.data)) {
            const ativas = response.data.filter((u) => u.ativo == 1);
            this.unidades = ativas;
            this._unidadesLoaded = true;
          } else if (response.data && response.data.erro) {
            EventBus.$emit('show-error', { error: { message: response.data.mensagem } });
            this.unidades = [];
          } else {
            this.unidades = [];
          }
        },
        onError: (e) => {
          console.log("Response : " + e.message);
          this.unidades = [];
        },
      });
    },
    qtdCarrosNaoReportado(item) {
      if (item > 0) {
        return "red";
      } else {
        return "green";
      }
    },
    isLinhaAtiva(item) {
      if (item == 0) {
        return "grey";
      } else {
        return "green";
      }
    },
    isReporting(item) {
      if (item == 0) {
        return "red";
      } else {
        return "green";
      }
    },
    // getIconPontoInteresse(icone) {
    //   return L.divIcon({
    //     className: "my-custom-pin",
    //     html: icone,
    //   });
    // },
    populaStatusVeiculosOperacao() {
      apiController.request(apiController.endpoints.getallStatusveiculosoperacao, {
        silent: true,
        onSuccess: (response) => {
          this.statusVeiculosOperacao = (response.data || []).map((status) => ({
            ...status,
            visivel: Number(status.visivel) ? 1 : 0,
            ativo: Number(status.ativo !== undefined && status.ativo !== null ? status.ativo : 1) ? 1 : 0,
            prioridade: Number(status.prioridade),
            descricao: translateDbField(status.translation_key, status.descricao),
          }));
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    isMarkerVisible(veiculo) {
      if (!this.markerVeiculosVisible) {
        return false;
      }

      return isVeiculoVisibleOnMap(
        veiculo,
        this.statusVeiculosOperacao,
        this.statusOperacaoContext,
        this.veiculoClicked?.id_veiculo
      );
    },
    getVeiculoPopupTrackerFields(veiculo) {
      const trackerKey = veiculo?.fabricante_rastreador_translation_key;
      return this.veiculoPopupFieldsByTracker[trackerKey] || [];
    },
    formatVeiculoPopupTrackerField(veiculo, field) {
      const formatter = this[field.formatter];
      if (typeof formatter !== 'function') {
        return veiculo[field.id] ?? '-';
      }
      return formatter(veiculo[field.id]);
    },
    formatStatusCanbus(value) {
      if (value == null) {
        return '-';
      }
      return value ? this.$t('operation.normal') : this.$t('operation.anormal');
    },
    formatStatusIgnicao(value) {
      if (value == null) {
        return '-';
      }
      if (value == 0) {
        return this.$t('operation.off');
      }
      if (value == 1) {
        return this.$t('operation.on');
      }
      return this.$t('operation.engineOn');
    },
    getIcon(veiculo) {
      const color = getVeiculoCor(veiculo, this.statusVeiculosOperacao, this.statusOperacaoContext);
      const size = this.veiculoClicked?.id_veiculo === veiculo.id_veiculo ? 40 : 30;
      const blink = veiculo.gps_offline === 1;
      const key = `${color}|${size}|${blink}`;
      const cache = this._iconCache || (this._iconCache = new Map());
      let icon = cache.get(key);
      if (!icon) {
        icon = createVeiculoOperacaoMapIcon(color, { size, blink });
        cache.set(key, icon);
      }
      return icon;
    },
    getIconPontosLinha() {
      return ICON_PONTOS_LINHA;
    },
    latLng: function (lat, lng) {
      const cache = this._latLngCache || (this._latLngCache = new Map());
      const key = `${lat}|${lng}`;
      let cached = cache.get(key);
      if (cached) {
        return cached;
      }
      if (lat != null && lng !== null) {
        if (lat.trim() !== "0") {
          cached = L.latLng(lat, lng);
        } else {
          cached = DEFAULT_MAP_CENTER;
        }
      } else {
        cached = DEFAULT_MAP_CENTER;
      }
      cache.set(key, cached);
      return cached;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    parseShape(linha, tipo) {
      if (tipo == 1 && linha.rotas.length > 0) {
        let lineColor = LineColors[this.currentLineColor];
        let coloredRotas = linha.rotas.map((r) => {
          if (r.geojson) {
            if (typeof r.geojson === "string") {
              r.geojson = Object.freeze(JSON.parse(r.geojson));
            } else if (r.geojson && typeof r.geojson === "object" && !Object.isFrozen(r.geojson)) {
              r.geojson = Object.freeze(r.geojson);
            }
            r.style = {
              color: lineColor,
            };
            r.options = {
              onEachFeature: (feat, layer) => {
                layer.bindPopup(feat.properties.name);
              }
            }
          }
          return r;
        })
        this.rotas.push(...coloredRotas);
        this.showRota = true;
      }
    },
    removeShape(idlinha) {
      this.rotas.forEach((r) => {
        if (r.id_linha === idlinha) {
          r.visible = false;
        }
      })
      this.rotas = this.rotas.filter((r) => r.linha ? !(r.linha.id_linha === idlinha) : !(r.id_linha === idlinha));

      this.cercas.forEach((c) => {
        if (c.id_linha === idlinha) {
          c.visible = false;
        }
      })
      this.cercas = this.cercas.filter((c) => !(c.id_linha === idlinha));

      this.pontosInteresse = this.pontosInteresse.filter((p) => !(p.id_linha === idlinha));
    },
    parseShapeNotificacao(shape) {
      var coords = [];
      if (shape === null) { return coords; }
      const array = JSON.parse(shape);
      if (array.length > 0) {
        for (var i = 0; i < array.length; i++) {
          coords.push({ lng: array[i].lg, lat: array[i].lt });
        }
      }
      return coords;
    },
    async openQuadroSinotico(linha) {
      if (!this.dialogSinotico) this.sinoticoLoading = true;
      this.keySinoticoIda = this.keySinoticoIda === 0 ? 1 : 0;
      this.keySinoticoVolta = this.keySinoticoVolta === 2 ? 3 : 2;
      this.dialogSinotico = true;
      this.linhaSelecionada = linha;
      try {
        await this.ensureLinhaRotasGeojson(linha);
      } catch (e) {
        this.closeQuadroSinotico();
        this.sinoticoLoading = false;
        console.log("Response : " + (e && e.message ? e.message : e));
        return;
      }
      const rotaIdaMeta = (linha.rotas || []).find((r) => r.id_tipo_rota == 1 && r.cod_sentido == 'IDA');
      const rotaVoltaMeta = (linha.rotas || []).find((r) => r.id_tipo_rota == 1 && r.cod_sentido == 'VOLTA');
      if (!rotaIdaMeta || !rotaIdaMeta.geojson || !rotaVoltaMeta || !rotaVoltaMeta.geojson) {
        this.closeQuadroSinotico();
        this.sinoticoLoading = false;
        return;
      }
      let geojsonIda = typeof rotaIdaMeta.geojson === 'string' ? JSON.parse(rotaIdaMeta.geojson) : rotaIdaMeta.geojson;
      let geojsonVolta = typeof rotaVoltaMeta.geojson === 'string' ? JSON.parse(rotaVoltaMeta.geojson) : rotaVoltaMeta.geojson;
      const rotaIda = geojsonIda.type === 'FeatureCollection' ? geojsonIda.features[0] : geojsonIda;
      const rotaVolta = geojsonVolta.type === 'FeatureCollection' ? geojsonVolta.features[0] : geojsonVolta;
      this.rotaIda = Object.freeze(rotaIda);
      this.rotaVolta = Object.freeze(rotaVolta);
      this.populaPosicoesSinotico(linha.id_linha);
    },
    atualizarSinotico(linha) {
      if (!linha) return;
      this.posicoesSinotico = this.veiculos.filter((v) => v.id_linha_guia !== null ? v.id_linha_guia === linha.id_linha : v.id_linha === linha.id_linha);
      this.veiculosLinhaSinoticoIda = this.posicoesSinotico.filter((v) => v.sentido === 0);
      this.veiculosLinhaSinoticoVolta = this.posicoesSinotico.filter((v) => v.sentido === 1);
    },
    closeQuadroSinotico() {
      this.dialogSinotico = false;
      this.distIdaLinha = 0;
      this.distVoltaLinha = 0;
      this.rotaIda = null;
      this.rotaVolta = null;
      this.linhaSelecionada = null;
    },
    populaPosicoesSinotico(idLinha) {
      this.posicoesSinotico = this.veiculos.filter((v) => v.id_linha_guia !== null ? v.id_linha_guia === idLinha : v.id_linha === idLinha);
      this.getPontosInteresseSinotico(idLinha);
    },
    getPontosInteresseSinotico(idLinha) {
      apiController.request(apiController.endpoints.getCercasporlinha, {
        data: [idLinha],
        onSuccess: (response) => {
          this.pontosPrincipaisSinotico = response.data.filter((c) => c.show_sinotico === 1 && (c.id_tipo_cerca === 2 || c.id_tipo_cerca === 3));
          this.pontosInteresseSinotico = response.data.filter((c) => c.show_sinotico === 1 && c.id_tipo_cerca === 1);
          this.veiculosLinhaSinoticoIda = this.posicoesSinotico.filter((v) => v.sentido === 0);
          this.veiculosLinhaSinoticoVolta = this.posicoesSinotico.filter((v) => v.sentido === 1);
          this.sinoticoLoading = false;
        },
        onError: (e) => {
          this.closeQuadroSinotico();
          this.sinoticoLoading = false;
          console.log("Response : " + e.message);
        },
      });

    },
    filterChanged() {
      this.setFilteredVeiculosLinha([]);
      this.filtersBreadcrumbs = [];

      const hasLegacyFilters = this.filters.length > 0;
      const hasStatusFilters = this.statusFilters.length > 0;
      const inconsistentLine = this.$t('operation.inconsistentLine');
      const inconsistentDriver = this.$t('operation.inconsistentDriver');
      const inconsistentCollector = this.$t('operation.inconsistentCollector');
      const inconsistentLineText = this.$t('operation.inconsistentLineText');
      const inconsistentDriverText = this.$t('operation.inconsistentDriverText');
      const inconsistentCollectorText = this.$t('operation.inconsistentCollectorText');

      if (hasLegacyFilters || hasStatusFilters) {
        let filtered = [];

        if (this.filters.includes(inconsistentLine)) {
          filtered.push(...this.veiculosLinha.filter((v) => {
            return v.id_guia !== null &&
              v.id_linha_guia !== v.id_linha &&
              v.gps_offline === 0 &&
              v.validador_offline === 0 &&
              v.cod_motorista_veiculo;
          }));
          this.filtersBreadcrumbs.push({ text: inconsistentLineText });
        }

        if (this.filters.includes(inconsistentDriver)) {
          filtered.push(...this.veiculosLinha.filter((v) => {
            return v.id_guia !== null &&
              v.id_motorista_guia === v.cod_motorista_veiculo &&
              v.gps_offline === 0 &&
              v.validador_offline === 0 &&
              v.cod_motorista_veiculo;
          }));
          this.filtersBreadcrumbs.push({ text: inconsistentDriverText });
        }

        if (this.filters.includes(inconsistentCollector)) {
          filtered.push(...this.veiculosLinha.filter((v) => {
            return v.id_guia !== null &&
              v.cod_cobrador_veiculo !== v.id_cobrador_guia &&
              v.gps_offline === 0 &&
              v.validador_offline === 0 &&
              v.cod_motorista_veiculo;
          }));
          this.filtersBreadcrumbs.push({ text: inconsistentCollectorText });
        }

        if (hasStatusFilters) {
          const selectedStatusSet = new Set(this.statusFilters);
          const context = this.statusOperacaoContext;
          const statusConfig = this.statusVeiculosOperacao;
          filtered.push(...this.veiculosLinha.filter((v) => {
            const resolved = resolveVeiculoStatus(v, statusConfig, context);
            return resolved && selectedStatusSet.has(resolved.cod_status);
          }));

          this.statusFiltrosDisponiveis.forEach((status) => {
            if (selectedStatusSet.has(status.cod_status)) {
              this.filtersBreadcrumbs.push({ text: status.descricao });
            }
          });
        }

        // Remove duplicatas quando o mesmo veículo casa com mais de um filtro
        const seen = new Set();
        filtered = filtered.filter((v) => {
          if (seen.has(v.id_veiculo)) return false;
          seen.add(v.id_veiculo);
          return true;
        });

        this.setFilteredVeiculosLinha(filtered);
      } else {
        this.setFilteredVeiculosLinha(this.veiculosLinha);
      }
    },
    selectedLinhaStyle(linha) {
      if (!this.linhasSelecionadasIds.has(linha.id_linha)) return "border: 1px #4a4a4a40 solid; border-radius: 5px; margin-bottom: 2px";
      return "background-color: #4a4a4a40; border: 2px #4a4a4a solid; border-radius: 5px; margin-bottom: 2px;";
    },
    selectedLinhaSubtitleStyle(linha) {
      if (!this.linhasSelecionadasIds.has(linha.id_linha)) return "";
      return "font-weight: bolder;";
    },
    colorChipVeiculo(item) {
      return getVeiculoCor(item, this.statusVeiculosOperacao, this.statusOperacaoContext);
    },
    filtersBreadcrumbsClicked() {
      this.showDrawer();
      this.filtrosExpanded = true;
    },
    closeBreadcrumbs() {
      this.filters = [];
      this.statusFilters = [];
      this.filterChanged();
    },
    sentidoFiltered() {
      let filtered = this.getCurrentFilteredVeiculosLinha();

      if (!this.showIda && !this.showVolta && !this.showDeslocamento) {
        filtered = filtered.filter((v) => v.sentido !== 1 || v.sentido !== 0);
        this.showRota = false;
        this.markerVeiculosVisible = false;
      } else {
        this.showRota = true;
        this.markerVeiculosVisible = true;
      }

      if (this.showIda && !this.showVolta) {
        filtered = filtered.filter((v) => v.sentido !== 1);
      }

      if (!this.showIda && this.showVolta) {
        filtered = filtered.filter((v) => v.sentido !== 0);
      }

      if (this.showIda && this.showVolta) {
        this.filterChanged();
      } else {
        this.setFilteredVeiculosLinha(filtered);
      }

    },
    showRotaChanged() {
      this.showIda = this.showRota;
      this.showVolta = this.showRota;
      this.showDeslocamento = this.showRota;
    },
    isPontoVisible(cerca) {
      return this.showRota && (cerca.id_tipo_cerca === 2 || cerca.id_tipo_cerca === 3);
    },
    getIdUnidadeVeiculo(veiculo, linhas) {
      let id_linha_veiculo = veiculo.id_linha_guia || veiculo.id_linha;
      let linha;
      if (linhas && typeof linhas.get === 'function') {
        linha = linhas.get(id_linha_veiculo);
        if (!linha && id_linha_veiculo != null) {
          linha = linhas.get(Number(id_linha_veiculo)) || linhas.get(String(id_linha_veiculo));
        }
      } else {
        linha = (linhas || []).find((l) => l.id_linha == id_linha_veiculo);
      }
      if (!linha) return undefined;
      if (!linha.unidades || linha.unidades.length === 0) return -1;
      return linha.unidades[0] ?? linha.id_unidade;
    },
    detalhesVeiculoClicked(veiculo) {
      if (this.veiculoClicked?.id_veiculo === veiculo.id_veiculo) {
        this.veiculoClicked = null;
      } else {
        this.veiculoClicked = veiculo;
        this.center = [veiculo.lat, veiculo.lng];
      }
    },
    pontoInteresseClicked(poi) {
      this.center = [poi.lat_centro, poi.lng_centro];
    },
    showMarkerCerca(tipoCerca) {
      return this.showCercasMapaOperacao && tipoCerca !== "GARAGEM";
    },
    navegaPosicoes(direcao) {
      if (direcao === "posterior") {
        if (this.indexPosicaoClicked < this.posicoesCarro.length) {
          this.indexPosicaoClicked += 1;
        }
      } else {
        if (this.indexPosicaoClicked > 0) {
          this.indexPosicaoClicked -= 1;
        }
      }
      this.showDetalhesPosicoes(this.indexPosicaoClicked)
    },
    buildMensagemNotificacao(notif) {
      if (!this) {
        return "";
      }
      return `${notif.descricao_tipo_notificacao} | ${notif.dt_notificacao_extenso.substring(10)} ${this.$tc('vehicle.self', 1)}: ${notif.cod_veiculo}`
    },
    closeSnackbar(close, index) {
      this.notifToReset = this.notificacoesImportantesVisiveis[index].notificacao;
      this.closeAlertFunction = close;
      this.resetNotificacao();
    },
    openMapaNotificacao(notif, cor) {
      this.notifClicked = notif;
      if (!this.map) {
        this.map = this.$refs.map.mapObject;
      }

      let notifMarker = this.markersNotif.findIndex((m) => m.id_notif === this.notifClicked.id_notificacao);

      if (notifMarker === -1) {
        let icon = L.divIcon({
          className: "my-custom-pin",
          html: `<svg fill="#000000" version="1.1" 
                          width="25" height="25" viewBox="0 0 437.699 437.699">
                      <path fill="${cor || 'red'}" d="M372.578,63.101c-41.18-32.332-95.775-50.138-153.727-50.138c-57.952,0-112.547,17.806-153.728,50.138
                              C23.127,96.073,0,140.162,0,187.244c0,47.688,24.536,93.246,67.589,126.027l-20.81,97.656c-0.893,4.186,0.629,8.518,3.94,11.227
                              c2.079,1.701,4.645,2.582,7.237,2.582c1.538,0,3.087-0.311,4.548-0.943l144.063-62.539c4.104,0.18,8.223,0.271,12.282,0.271
                              c57.952,0,112.545-17.807,153.727-50.139c41.996-32.973,65.123-77.061,65.123-124.144
                              C437.701,140.162,414.574,96.073,372.578,63.101z M218.852,304.393c-15.709,0-28.49-12.78-28.49-28.489
                              c0-15.71,12.781-28.491,28.49-28.491c15.708,0,28.49,12.781,28.49,28.491C247.342,291.612,234.561,304.393,218.852,304.393z
                              M240.721,215.57c-0.771,11.446-10.367,20.417-21.844,20.417c-0.499,0-1.002-0.016-1.505-0.051
                              c-10.867-0.737-19.624-9.498-20.355-20.376l-6.931-102.056c-0.522-7.686,1.98-15.118,7.049-20.926
                              c5.068-5.806,12.092-9.29,19.779-9.813c0.653-0.044,1.313-0.066,1.962-0.066c15.11,0,27.757,11.813,28.778,26.894
                              C248.202,116.2,240.721,215.57,240.721,215.57z"/>
                      </svg>`,
          iconAnchor: [5, 25]
        });
        this.markersNotif.push({
          marker: L.marker([this.notifClicked.lat, this.notifClicked.lng], { icon: icon })
            .bindPopup(`${this.notifClicked.cod_veiculo} | ${this.notifClicked.descricao_tipo_notificacao}`, { offset: new L.Point(0, -10) })
            .addTo(this.map), id_notif: this.notifClicked.id_notificacao
        });
      } else {
        this.map.removeLayer(this.markersNotif[notifMarker].marker);
        this.markersNotif.splice(notifMarker, 1);
        this.notifClicked = null;
      }
    },
    atualizaEndereco(endereco) {
      this.notifClicked.tem_endereco = 1;
      this.notifClicked.rua = endereco.street;
      this.notifClicked.numero = endereco.houseNumber;
      this.notifClicked.bairro = endereco.district;
      this.notifClicked.cidade = endereco.city;
      this.notifClicked.uf = endereco.stateCode;
      this.notifClicked.cep = endereco.postalCode;

      this.notificacoesImportantesVisiveis[
        this.notificacoesImportantesVisiveis.findIndex((n) => n.notificacao.id_notificacao === this.notifClicked.id_notificacao)
      ].notificacao = this.notifClicked;
    },
    populaTiposEntrada() {
      apiController.request(apiController.endpoints.getallTiposentrada, {
        silent: true,
        onSuccess: (response) => {
          this.tiposEntradaDiario = response.data
          this.tiposEntradaDiario.forEach(tipo => {
            tipo.descricao_tipo_entrada = translateDbField(
              tipo.translation_key,
              tipo.descricao_tipo_entrada
            );
            return tipo;
          });
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaMotivos() {
      apiController.request(apiController.endpoints.getallMotivos, {
        silent: true,
        onSuccess: (response) => {
          this.motivos = response.data
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaViagensLinha() {
      if (this.diarioLinhas.length > 0) {
        apiController.request(apiController.endpoints.getViagensprevistaslinha, {
          data: this.diarioLinhas,
          onSuccess: (response) => {
            this.viagens = response.data
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
          },
        });
      }
    },
    populaEntradasDiario() {
      this.loadingDiario = true;
      let today = DateUtils.getDateSQLFormatted(new Date());
      let dataInicial = today.substring(0, 10) + "T00:00:00";
      let dataFinal = today;

      let body = {
        dti: dataInicial,
        dtf: dataFinal,
        idlinhas: null,
        idveiculos: null,
        idviagensprevistas: null,
        idviagensrealizadas: null
      }

      apiController.request(apiController.endpoints.getEntradaspordata, {
        data: body,
        silent: true,
        onSuccess: (response) => {
          this.entradasDiario = response.data;
          this.entradasDiario.forEach(entrada => {
            entrada.descricao_tipo_entrada = translateDbField(
              entrada.translation_key,
              entrada.descricao_tipo_entrada
            );
            return entrada;
          });
          this.loadingDiario = false;
        },
        onError: (e) => {
          this.loadingDiario = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    openDiarioBordo() {
      let today = new Date();
      this.dtEntradaDiario = today;
      this.populaMotivos();
      this.populaTiposEntrada();
      this.populaEntradasDiario();
      this.dialogDiarioBordo = true;
    },
    closeDiarioBordo() {
      this.$refs.diarioForm.resetValidation();
      this.itemDiario = Object.assign({}, this.defaultItemDiario);
      this.dialogDiarioBordo = false;
    },
    saveEntrada() {
      if (this.editingDiario) {
        apiController.request(apiController.endpoints.updateEntrada, {
          data: this.itemDiario,
          silent: true,
          onSuccess: () => {
            EventBus.$emit('show-alert', {
              tipo: 'success',
              mensagem: this.$t('system.messages.editedSuccess')
            });
            this.populaEntradasDiario();
            this.closeEditEntrada();
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            this.closeEditEntrada();
            EventBus.$emit('show-alert', {
              tipo: 'error',
              mensagem: e.message
            });
          },
        });
      } else {
        if (this.$refs.diarioForm.validate()) {
          this.itemDiario.dt_entrada = DateUtils.getDateSQLFormatted(this.dtEntradaDiario);
          this.itemDiario.id_usuario_inclusao = this.id_usuario;

          apiController.request(apiController.endpoints.insertEntrada, {
            data: this.itemDiario,
            silent: true,
            onSuccess: (response) => {
              this.saveLinhasEntrada(response.data.insertId);
            },
            onError: (e) => {
              console.log(this.$t('system.messages.errorAxios'));
              console.log(e.message);
              EventBus.$emit('show-alert', { tipo: 'error', mensagem: e.message });
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog =
                  this.$t('system.messages.accessDenied');
                this.autorizacaoDialog = true;
              }
            },
          });
        }
      }
    },
    saveLinhasEntrada(idEntrada) {
      if (this.diarioLinhas.length > 0) {
        let temp = this.diarioLinhas.map((e) => {
          return [idEntrada, e];
        });

        apiController.request(apiController.endpoints.insertLinhasentradabulk, {
          data: temp,
          silent: true,
          onSuccess: () => {
            this.saveVeiculosEntrada(idEntrada);
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            EventBus.$emit('show-alert', {
              tipo: 'error',
              mensagem: e.message
            });
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          },
        });
      } else {
        this.saveVeiculosEntrada(idEntrada);
      }
    },
    saveVeiculosEntrada(idEntrada) {
      if (this.diarioVeiculos.length > 0) {
        let temp = this.diarioVeiculos.map((e) => {
          return [idEntrada, e];
        });

        apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
          data: temp,
          silent: true,
          onSuccess: () => {
            this.saveViagensEntrada(idEntrada);
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            EventBus.$emit('show-alert', {
              tipo: 'error',
              mensagem: e.message
            });
          },
        });
      } else {
        this.saveViagensEntrada(idEntrada);
      }
    },
    saveViagensEntrada(idEntrada) {
      if (this.diarioViagens.length > 0) {
        let temp = this.diarioViagens.map((e) => {
          return [idEntrada, e];
        });

        apiController.request(apiController.endpoints.insertViagensprevistasentradabulk, {
          data: temp,
          silent: true,
          onSuccess: () => {
            EventBus.$emit('show-alert', {
              tipo: 'success',
              mensagem: this.$t('operation.diaryEntrySuccess')
            });
            this.itemDiario = Object.assign({}, this.defaultItemDiario);
            this.diarioLinhas = [];
            this.diarioVeiculos = [];
            this.diarioViagens = [];
            this.$refs.diarioForm.resetValidation();
            this.populaEntradasDiario();
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            EventBus.$emit('show-alert', {
              tipo: 'error',
              mensagem: e.message
            });
          },
        });
      } else {
        EventBus.$emit('show-alert', {
          tipo: 'success',
          mensagem: this.$t('operation.diaryEntrySuccess')
        });
        this.itemDiario = Object.assign({}, this.defaultItemDiario);
        this.$refs.diarioForm.resetValidation();
        this.populaEntradasDiario();
      }
    },
    onLinhaDiarioChanged() {
      this.viagens = [];
      this.populaViagensLinha();
    },
    plotarEndereco(local) {
      if (!this.map) {
        this.map = this.$refs.map.mapObject;
      }

      if (local) {
        if (this.searchMarker) {
          this.map.removeLayer(this.searchMarker);
        }
        this.searchMarker = local.marker;
        this.map.addLayer(this.searchMarker);
        this.searchMarker.openPopup();
        this.center = [this.searchMarkerPos.lat, this.searchMarkerPos.lng];
      }
      let parametro = {
        dt_registro: DateUtils.getDateSQLFormatted(new Date()),
        valor: 1
      }
      apiController.request(apiController.endpoints.updateChamadashereapi, {
        data: parametro,
        silent: true,
        onError: (e) => {
          console.log(e);
        },
      });
    },
    limparEndereco() {
      if (!this.map) {
        this.map = this.$refs.map.mapObject;
      }

      if (this.searchMarker) {
        this.map.removeLayer(this.searchMarker);
      }
    },
    showResetNotificacaoDialog(notif) {
      if (notif) {
        this.mensagemResetDialog = this.$t('operation.confirmReset');
        this.notifToReset = notif;
      } else {
        this.mensagemResetDialog = this.$t('operation.confirmResetAllNotifications');
        this.notifToReset = null;
      }

      this.confirmResetDialog = true;
    },
    resetNotificacao() {
      this.confirmResetDialog = false;

      if (this.notifToReset) {
        apiController.request(apiController.endpoints.updateNotificacao, {
          data: { id_notificacao: this.notifToReset.id_notificacao },
          silent: true,
          onSuccess: () => {
            if (this.closeAlertFunction) {
              this.closeAlertFunction();
            }
            let notifMarker = this.markersNotif.findIndex((m) => m.id_notif === this.notifClicked.id_notificacao);
            if (notifMarker !== -1) {
              this.map.removeLayer(this.markersNotif[notifMarker].marker);
              this.markersNotif.splice(notifMarker, 1);
            }
            this.notifToReset = null;
            this.closeAlertFunction = null;
            EventBus.$emit('operacao-notificacoes-refresh');
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      } else {
        let dtinicio = new Date();
        dtinicio.setDate(dtinicio.getDate() - 1);
        let dti = DateUtils.getDateSQLFormatted(dtinicio);
        let dtf = DateUtils.getDateSQLFormatted(new Date());
        apiController.request(apiController.endpoints.updateNotificacaoporperiodo, {
          data: { dtinicio: dti, dtfim: dtf },
          silent: true,
          onSuccess: () => {
            EventBus.$emit('operacao-notificacoes-refresh');
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    editEntrada(entrada) {
      this.itemDiario = Object.assign({}, entrada);
      this.itemDiario.id_usuario_edicao = this.id_usuario;
      this.itemDiario.dt_edicao = DateUtils.getDateSQLFormatted(new Date());
      this.editingDiario = true;
      this.dialogEditEntrada = true;
    },
    closeEditEntrada() {
      this.itemDiario = Object.assign({}, this.defaultItemDiario);
      this.editingDiario = false;
      this.dialogEditEntrada = false;
      if (this.$refs.diarioForm) {
        this.$refs.diarioForm.resetValidation();
      }
    },
    deleteEntrada(entrada) {
      this.itemDiario = Object.assign({}, entrada);
      this.itemDiario.id_usuario_edicao = this.id_usuario;
      this.itemDiario.dt_edicao = DateUtils.getDateSQLFormatted(new Date());
      this.dialogDeleteEntrada = true;
    },
    closeDeleteEntrada() {
      this.itemDiario = Object.assign({}, this.defaultItemDiario);
      this.dialogDeleteEntrada = false;
      if (this.$refs.diarioForm) {
        this.$refs.diarioForm.resetValidation();
      }
    },
    confirmDeleteEntrada() {
      apiController.request(apiController.endpoints.deleteEntrada, {
        data: this.itemDiario,
        silent: true,
        onSuccess: () => {
          EventBus.$emit('show-alert', {
            tipo: 'success',
            mensagem: this.$t('operation.diaryEntrySuccess')
          });
          this.populaEntradasDiario();
          this.closeDeleteEntrada();
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          this.closeDeleteEntrada();
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: e.message
          });
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('message.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    selectIcon(selection, items) {
      const itemsSemSeparadores = items.filter((i) => !i.isSeparator);
      if (selection.length === itemsSemSeparadores.length) return 'mdi-close-box';
      if (selection.length > 0) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    toggleAllVeiculos() {
      this.$nextTick(() => {
        const itemsSemSeparadores = this.veiculosStandAlone.filter((i) => !i.isSeparator);
        if (this.veiculosStandAloneSelected.length === itemsSemSeparadores.length) {
          this.veiculosStandAloneSelected = [];
        } else {
          this.veiculosStandAloneSelected = itemsSemSeparadores.map((item) => item.display);
        }
        this.veiculoStandAloneChanged();
      })
    },
    getEtaFormatted(eta) {
      if (!eta) {
        return null;
      }

      if (eta < 0) {
        return this.$t('datetime.now');
      }

      let hours = Math.round(eta / 3600);
      let minutes = Math.round((eta % 3600) / 60);

      if (hours === 0 && minutes === 0) {
        return this.$t('datetime.now');
      }

      let hoursFormatted = hours < 10 ? '0' + hours.toString() : hours.toString();
      let minutesFormatted = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      return `${hoursFormatted}:${minutesFormatted}`
    },
    showUltimasPosicoesVeiculo(item) {
      let dtf = new Date(item.dt_ultima_posicao);
      let dti = new Date(item.dt_ultima_posicao);
      dti.setDate(dti.getDate() - 1);
      this.loadingUltimasPosicoesVeiculo = true;

      const payload = {
        idveiculo: item.id_veiculo,
        dti: DateUtils.getDateSQLFormatted(dti),
        dtf: DateUtils.getDateSQLFormatted(dtf)
      }

      apiController.request(apiController.endpoints.getPosicoesporcarrodatamanutencao, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          this.ultimasPosicoesVeiculo = response.data;
          this.loadingUltimasPosicoesVeiculo = false;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          this.loadingUltimasPosicoesVeiculo = false;
        },
      });

      this.dialogUltimasPosicoesVeiculo = true;
    },
    closeUltimasPosicoesVeiculo() {
      this.ultimasPosicoesVeiculo = [];
      this.dialogUltimasPosicoesVeiculo = false;
    },
    getColorPosicao(item) {
      if (item.is_valid == 0) {
        return "item__com__problema";
      }

      return null;
    }
  },
};
</script>
